import React, { useState, useEffect } from 'react';
import api, { bijouxAPI, API_URL, getServerUrl } from '../../services/api';
import {
  Search, Eye, Edit, Trash2, MapPin, Package, ShoppingCart,
  TrendingUp, Filter, X, ChevronDown, ChevronUp, History,
  AlertCircle, Clock, Gem, Plus, Upload, Save, Play, Minus,
  LayoutList, Grid3x3, CheckCircle
} from 'lucide-react';
import CreerBijou from './CreerBijou';
import CatalogueBijoux from './CatalogueBijoux';
import HistoriqueProductionModal from './HistoriqueProductionModal';
import CoutDetailBlock from './CoutDetailBlock';
import FicheCalculMoteur from './FicheCalculMoteur';
import FicheBijouTermineModal from '../Atelier/FicheBijouTermineModal';

function BijouxAvance() {
  // Contexte workspace
  const _ctx = (() => { try { return JSON.parse(localStorage.getItem('workspaceContext') || '{}'); } catch { return {}; } })();
  const isBoutique = _ctx.type === 'boutique';
  // §202 — Rôle réel : une vendeuse (role 'boutique') n'a JAMAIS accès au coût/marge
  // ni aux actions de mutation. Gate par rôle (pas par contexte) : un admin qui
  // visite le contexte boutique garde sa vue complète.
  const _user = (() => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; } })();
  const isVendeuse = _user.role === 'boutique';

  const [bijoux, setBijoux] = useState([]);
  const [filteredBijoux, setFilteredBijoux] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBijou, setSelectedBijou] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  // const [showFilters, setShowFilters] = useState(false);
  const [traceData, setTraceData] = useState(null);
  const [loadingTrace, setLoadingTrace] = useState(false);
  const [showHistoriqueModal, setShowHistoriqueModal] = useState(false);
  const [historiqueBijouId, setHistoriqueBijouId] = useState(null);
  // Chantier 4 : sub-modal Fiche OF
  const [showFicheOF, setShowFicheOF] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingBijou, setEditingBijou] = useState(null);
  // Edition rapide du prix (icone €) — maj prix_vente + pvp_magasin ensemble, log backend
  const [editPrix, setEditPrix] = useState(null); // { bijou, prix }

  const sauverPrix = async () => {
    if (!editPrix) return;
    try {
      const res = await fetch(`${API_URL}/bijoux/${editPrix.bijou.id}/prix`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ nouveau_prix: parseFloat(editPrix.prix), motif: 'edition_manuelle' }),
      });
      const d = await res.json();
      if (!res.ok) { alert(d.error || 'Erreur'); return; }
      setEditPrix(null);
      loadBijoux();
    } catch (e) { alert('Erreur réseau'); }
  };
  const [newBijou, setNewBijou] = useState({
    reference: '',
    nom: '',
    categorie: 'bague',
    matiere: 'or',
    poids: '',
    prix_achat: '',
    prix_vente: '',
    description: '',
    dimensions: '',
    pierres: '',
    certificat: '',
    stock_minimum: 5,
    image_url: '',
    collection_nom: ''
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [bijouPhotos, setBijouPhotos] = useState([]);
  const [photosPreviews, setPhotosPreviews] = useState([]);
  const [saving, setSaving] = useState(false);
  const [bijouFichiers, setBijouFichiers] = useState([]);
  const [uploadingFichier, setUploadingFichier] = useState(false);

  // Panier de production
  const [panier, setPanier] = useState([]);
  const [panierOuvert, setPanierOuvert] = useState(false);
  const [lancementEnCours, setLancementEnCours] = useState(false);
  // Client pour lequel on lance la production
  const [clientProd, setClientProd]       = useState('');
  // Nouvelle ligne en cours de saisie
  const [nouvelleLigne, setNouvelleLigne] = useState({ reference_article: '', couleur_or: 'JAUNE', quantite: 1, nom: '' });
  // Lookup modèle
  const [modeleInfo, setModeleInfo]       = useState(null);   // { trouve, modele }
  const [lookupEnCours, setLookupEnCours] = useState(false);
  const lookupTimer = React.useRef(null);
  // Résultat après lancement
  const [resultatLancement, setResultatLancement] = useState(null);  // { numero_of, pieces }
  // Pièce en cours de personnalisation
  const [pieceEnEdition, setPieceEnEdition]     = useState(null);
  const [champsPiece, setChampsPiece]           = useState({});

  // Fiche fabrication complète
  const [ficheFabBijouId, setFicheFabBijouId]   = useState(null);
  const [ficheFabData, setFicheFabData]         = useState(null);
  const [ficheFabLoading, setFicheFabLoading]   = useState(false);
  const [ficheFabSaving, setFicheFabSaving]     = useState(false);
  const [ficheFabFichiers, setFicheFabFichiers] = useState([]);
  const [uploadingFicheFab, setUploadingFicheFab] = useState(false);
  const [etapesDisponibles, setEtapesDisponibles] = useState([]);
  const [optionsDisponibles, setOptionsDisponibles] = useState([]);

  // Vue liste / catalogue / production
  const [vueMode, setVueMode] = useState('liste');
  // Inclure les pièces vendues dans la vue liste (par défaut : stock uniquement)
  const [inclureVendus, setInclureVendus] = useState(false);

  // Arrivee depuis le Rapport Bijoux (clic alerte) : ?search=<id_produit>&vendus=1
  useEffect(() => {
    const qp = new URLSearchParams(window.location.search);
    const q = qp.get('search');
    if (q) {
      setSearchTerm(q);
      setVueMode('liste');
      if (qp.get('vendus') === '1') setInclureVendus(true);
      // nettoie l'URL pour ne pas re-appliquer au refresh
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Filtres

  // Recharge selon l'onglet : liste = stock_only (sauf inclureVendus), production = en_production
  useEffect(() => {
    if (vueMode === 'catalogue') return;
    loadBijoux();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vueMode, inclureVendus]);

  useEffect(() => {
    filterBijoux();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, bijoux]);

  const loadBijoux = async () => {
    try {
      const params = { limit: 2000 }; // backend max — import massif 1500-2000 bijoux prévu
      if (vueMode === 'production') {
        params.en_production = 'true';
      } else if (!inclureVendus) {
        params.stock_only = 'true';
      }
      const response = await bijouxAPI.getAll(params);
      setBijoux(response.data);
      setFilteredBijoux(response.data);
    } catch (error) {
      console.error('Erreur chargement bijoux:', error);
    } finally {
      setLoading(false);
    }
  };

  // ── Ouvrir la fiche fabrication complète ──────────────────────────────
  const ouvrirFicheFab = async (bijouId) => {
    setFicheFabBijouId(bijouId);
    setFicheFabLoading(true);
    try {
      // Si bijouId est un nombre → /bijoux/123/fiche-complete
      // Sinon (reference_article) → /bijoux/ref/BAGB21/fiche-complete
      const isNumeric = typeof bijouId === 'number' || /^\d+$/.test(bijouId);
      const ficheUrl = isNumeric
        ? `/bijoux/${bijouId}/fiche-complete`
        : `/bijoux/ref/${bijouId}/fiche-complete`;
      const [ficheRes, etapesRes, optionsRes] = await Promise.all([
        api.get(ficheUrl),
        api.get('/bijoux/etapes-disponibles'),
        api.get('/bijoux/options-disponibles'),
      ]);
      const fiche = ficheRes.data;
      const etapesData = etapesRes.data;
      const optData = optionsRes.data;

      setEtapesDisponibles(etapesData.templates || []);
      setOptionsDisponibles(optData.composants || []);
      // Stocker pierres/matières/collections disponibles dans le state
      const _pierresStock = optData.pierres_stock || [];
      const _matieresStock = optData.matieres_stock || [];
      const _collectionsListe = optData.collections || [];

      const b = fiche.bijou || {};
      setFicheFabBijouId(b.id);
      setFicheFabData({
        // Infos générales
        nom: b.nom || '',
        couleur_or: b.couleur_or || 'JAUNE',
        matiere: b.matiere || 'or',
        collection_nom: b.collection_nom || '',
        description: b.description || '',
        consigne: b.consigne || '',
        genre: b.genre || '',
        // Poids
        poids_brut: b.poids_brut || '',
        poids_metal_net: b.poids_metal_net || '',
        poids_metal_travaille: b.poids_metal_travaille || '',
        poids_chaine: b.poids_chaine || '',
        poids_mousqueton: b.poids_mousqueton || '',
        poids_pierres_carats: b.poids_pierres_carats || '',
        poids_metal: b.poids_metal || '',
        // Prix
        prix_achat: b.prix_achat || '',
        prix_vente: b.prix_vente || '',
        prix_or_fabrication: b.prix_or_fabrication || '',
        cout_metal: b.cout_metal || '',
        cout_pierres: b.cout_pierres || '',
        cout_main_oeuvre: b.cout_main_oeuvre || '',
        coefficient_marge: b.coefficient_marge || '',
        // Poids or donné/rendu/final
        poids_or_donne: b.poids_or_donne || '',
        poids_or_rendu: b.poids_or_rendu || '',
        poids_final_sans_pierres: b.poids_final_sans_pierres || '',
        // Prix théorique vs réel
        prix_theorique: b.prix_theorique || '',
        cout_reel_total: b.cout_reel_total || '',
        cout_reel_main_oeuvre: b.cout_reel_main_oeuvre || '',
        cout_reel_metal: b.cout_reel_metal || '',
        // Divers
        dimensions: b.dimensions || '',
        certificat: b.certificat || '',
        notes_variation: b.notes_variation || '',
        observation_piece: b.observation_piece || '',
        // Matières or — pré-remplir depuis le poids métal du bijou
        matieres_utilisees: (b.poids_metal || b.poids_brut) ? [{
          stock_matiere_id: 'auto',
          designation: `Or 18k ${(b.couleur_or || 'JAUNE').toLowerCase()}`,
          type_matiere: 'OR 18K',
          quantite: b.poids_metal || b.poids_brut || '',
          prix_achat_unitaire: '',
        }] : [],
        // Composants fabrication sélectionnés (du bijou)
        composants: (fiche.composants || []).map(c => ({
          cout_fabrication_id: c.cout_fabrication_id,
          nom: c.nom,
          quantite: c.quantite || 1,
          prix_unitaire: c.prix_unitaire || c.cout,
          cout_total: c.cout_total || 0,
          notes: c.notes || '',
        })),
        // Pierres — depuis of_pierres, ou fallback depuis le champ texte "pierres"
        pierres_of: (() => {
          if (fiche.pierres_of && fiche.pierres_of.length > 0) {
            return fiche.pierres_of.map(p => ({
              type_pierre: p.type_pierre || '', designation: p.designation || p.type_pierre || '',
              quantite: p.quantite || 1, poids_carats: p.poids_carats || 0,
              sertisseur: p.sertisseur || '', observation: p.observation || '',
              prix_achat_carat: p.prix_achat_carat || '', stock_matiere_id: p.stock_matiere_id || null,
            }));
          }
          if (b.pierres && b.pierres.trim()) {
            return [{ type_pierre: b.pierres.trim(), designation: b.pierres.trim(), quantite: 1,
              poids_carats: b.poids_pierres_carats || 0, sertisseur: '', observation: '',
              prix_achat_carat: '', stock_matiere_id: null }];
          }
          return [];
        })(),
        // Packaging
        packaging_id: b.packaging_id || null,
        // Infos read-only
        _reference_article: b.reference_article,
        _id_produit: b.id_produit,
        _packaging_list: optData.packaging || [],
        _pierres_stock: _pierresStock,
        _matieres_stock: _matieresStock,
        _collections_liste: _collectionsListe,
        _of_data: fiche.of_data || null,
        _etapes_production: fiche.etapes_production || [],
        _etapes_fabrication: fiche.etapes_fabrication || [],
        _ouvriers_production: fiche.ouvriers_production || [],
        _date_fabrication: b.date_fabrication,
        _statut_fabrication: b.statut_fabrication,
      });
      // Charger les fichiers (photos, certificats, docs)
      if (b.id) {
        fetch(`${API_URL}/bijoux-images/bijou/${b.id}/fichiers`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } })
          .then(r => r.ok ? r.json() : [])
          .then(d => setFicheFabFichiers(Array.isArray(d) ? d : []))
          .catch(() => setFicheFabFichiers([]));
      }
    } catch (err) {
      console.error('Erreur chargement fiche:', err);
      const url404 = err?.config?.url || '?';
      const status = err?.response?.status || '?';
      const detail = err?.response?.data?.error || err.message;
      alert(`Erreur fiche fabrication [${status}] ${url404}\n${detail}`);
      setFicheFabBijouId(null);
    } finally {
      setFicheFabLoading(false);
    }
  };

  const sauverFicheFab = async () => {
    if (!ficheFabBijouId || !ficheFabData) return;
    setFicheFabSaving(true);
    try {
      const payload = { ...ficheFabData };
      // Retirer toutes les clés internes (commencent par _)
      Object.keys(payload).forEach(k => { if (k.startsWith('_')) delete payload[k]; });
      await api.put(`/bijoux/${ficheFabBijouId}/fiche-complete`, payload);
      setFicheFabBijouId(null);
      setFicheFabData(null);
      loadBijoux();
    } catch (e) {
      alert('Erreur réseau : ' + e.message);
    } finally {
      setFicheFabSaving(false);
    }
  };

  const filterBijoux = () => {
    let filtered = [...bijoux];

    // Recherche rapide — couvre id_produit, ref_article, description, nom, collection
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(b =>
        b.id_produit?.toLowerCase().includes(term) ||
        b.reference?.toLowerCase().includes(term) ||
        b.ref_article?.toLowerCase().includes(term) ||
        b.reference_article?.toLowerCase().includes(term) ||
        b.description?.toLowerCase().includes(term) ||
        b.nom?.toLowerCase().includes(term) ||
        b.categorie?.toLowerCase().includes(term) ||
        b.collection_nom?.toLowerCase().includes(term) ||
        b.client_nom?.toLowerCase().includes(term)
      );
    }

    setFilteredBijoux(filtered);
  };

  const loadTraceComplete = async (bijouId) => {
    setLoadingTrace(true);
    try {
      const response = await fetch(`${API_URL}/bijoux/${bijouId}/trace-complete`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      setTraceData(data);
    } catch (error) {
      console.error('Erreur chargement traçabilité:', error);
    } finally {
      setLoadingTrace(false);
    }
  };

  const handleViewDetails = async (bijou) => {
    setSelectedBijou(bijou);
    setShowDetailModal(true);
    await loadTraceComplete(bijou.id);
  };

  // ── Lookup auto de la référence ──────────────────────────────────────────
  const rechercherModele = (ref) => {
    clearTimeout(lookupTimer.current);
    if (ref.length < 2) { setModeleInfo(null); return; }
    setLookupEnCours(true);
    lookupTimer.current = setTimeout(async () => {
      try {
        // Si format id_produit (commence par "1." ou "9.") -> route lookup unifie
        // Sinon -> route legacy modele-reference (compat)
        const isIdProduit = /^\d+\.\d+/.test(ref);
        if (isIdProduit) {
          const res = await fetch(`${API_URL}/bijoux/lookup?q=${encodeURIComponent(ref)}&limit=1`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          const data = await res.json();
          if (data.results && data.results.length > 0) {
            const b = data.results[0];
            // Format compat avec modele-reference
            setModeleInfo({
              trouve: true,
              source: 'bijoux',
              modele: {
                reference_article: b.reference_article,
                nom: b.nom,
                categorie: b.categorie,
                couleur_or: b.couleur_or,
                poids: b.poids,
                matiere: b.matiere,
                prix_vente: b.prix_vente,
                description: '',
                nb_existants: 1,
                nb_en_stock: b.inventaire_actif ? 1 : 0,
              }
            });
            // Auto-fill reference_article + nom + couleur depuis id_produit lookup
            setNouvelleLigne(prev => ({
              ...prev,
              reference_article: b.reference_article || prev.reference_article,
              nom: prev.nom || b.nom || '',
              couleur_or: prev.couleur_or || b.couleur_or || 'JAUNE',
            }));
          } else {
            setModeleInfo({ trouve: false });
          }
        } else {
          // Recherche par reference_article (legacy)
          const res = await fetch(`${API_URL}/bijoux/modele-reference/${ref}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          const data = await res.json();
          setModeleInfo(data);
          if (data.trouve && data.modele?.nom) {
            setNouvelleLigne(prev => ({ ...prev, nom: prev.nom || data.modele.nom }));
          }
        }
      } catch { setModeleInfo(null); }
      finally { setLookupEnCours(false); }
    }, 400);
  };

  const ajouterLignePanier = () => {
    const ref = nouvelleLigne.reference_article.trim().toUpperCase();
    if (!ref) return;
    const qte = Math.max(1, parseInt(nouvelleLigne.quantite) || 1);
    const nomDefaut = modeleInfo?.modele?.nom || ref;
    setPanier(prev => [...prev, {
      id: Date.now(),
      reference_article: ref,
      couleur_or: nouvelleLigne.couleur_or,
      quantite: qte,
      nom: nouvelleLigne.nom || nomDefaut,
    }]);
    setNouvelleLigne({ reference_article: '', couleur_or: 'JAUNE', quantite: 1, nom: '' });
    setModeleInfo(null);
    setPanierOuvert(true);
  };

  // Garder aussi la possibilité d'ajouter depuis la liste
  const ajouterAuPanier = (bijou) => {
    const ref = (bijou.reference_article || bijou.reference || '').toUpperCase();
    setPanier(prev => [...prev, {
      id: Date.now(),
      reference_article: ref,
      couleur_or: bijou.couleur_or || 'JAUNE',
      quantite: 1,
      nom: bijou.nom || bijou.nom_modele || bijou.description || ref,
    }]);
    setPanierOuvert(true);
  };

  const retirerDuPanier = (id) => setPanier(prev => prev.filter(item => item.id !== id));

  const changerQuantite = (id, delta) => {
    setPanier(prev => prev.map(item => {
      if (item.id !== id) return item;
      const q = item.quantite + delta;
      return q < 1 ? null : { ...item, quantite: q };
    }).filter(Boolean));
  };

  const changerCouleurPanier = (id, couleur) => {
    setPanier(prev => prev.map(item => item.id === id ? { ...item, couleur_or: couleur } : item));
  };

  const lancerProductionPanier = async () => {
    if (panier.length === 0) return;
    const total = panier.reduce((t, i) => t + i.quantite, 0);
    if (!window.confirm(`Lancer la production de ${total} pièce(s) ?`)) return;
    setLancementEnCours(true);
    try {
      const res = await fetch(`${API_URL}/bijoux/lancer-production`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ lignes: panier, client_nom: clientProd }),
      });
      const data = await res.json();
      if (res.ok) {
        setResultatLancement(data);
        setPanier([]);
        setPanierOuvert(false);
        loadBijoux();
      } else {
        alert('Erreur : ' + (data.error || 'inconnue'));
      }
    } catch (e) {
      alert('Erreur réseau : ' + e.message);
    } finally {
      setLancementEnCours(false);
    }
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePhotosUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setBijouPhotos([...bijouPhotos, ...files]);
      const newPreviews = files.map(file => URL.createObjectURL(file));
      setPhotosPreviews([...photosPreviews, ...newPreviews]);
    }
  };

  const removePhoto = (index) => {
    const newPhotos = bijouPhotos.filter((_, i) => i !== index);
    const newPreviews = photosPreviews.filter((_, i) => i !== index);
    setBijouPhotos(newPhotos);
    setPhotosPreviews(newPreviews);
  };

  const handleCreateBijou = async () => {
    setSaving(true);
    try {
      let imageUrl = newBijou.image_url;
      
      // Si une image a été sélectionnée, l'uploader
      if (imageFile) {
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('type_creation', newBijou.collection_nom ? 'BIJOUTERIE' : 'CLIENT');
        formData.append('type_bijou', newBijou.categorie || 'bijou');
        formData.append('collection_nom', newBijou.collection_nom || '');
        formData.append('reference', newBijou.reference || '');
        
        const uploadResponse = await fetch(`${API_URL}/bijoux-images/upload`, {
          method: 'POST',
          body: formData
        });
        
        if (uploadResponse.ok) {
          const data = await uploadResponse.json();
          imageUrl = data.url;
        }
      }

      // Créer le bijou
      await bijouxAPI.create({
        ...newBijou,
        image_url: imageUrl,
        poids: newBijou.poids ? parseFloat(newBijou.poids) : null,
        prix_achat: parseFloat(newBijou.prix_achat) || 0,
        prix_vente: parseFloat(newBijou.prix_vente) || 0,
        stock_minimum: parseInt(newBijou.stock_minimum) || 5
      });

      // Réinitialiser et recharger
      setShowCreateModal(false);
      setNewBijou({
        reference: '',
        nom: '',
        categorie: '',
        matiere: '',
        poids: '',
        prix_achat: '',
        prix_vente: '',
        description: '',
        dimensions: '',
        pierres: '',
        certificat: '',
        stock_minimum: 5,
        image_url: '',
        collection_nom: ''
      });
      setImageFile(null);
      setImagePreview(null);
      setBijouPhotos([]);
      setPhotosPreviews([]);
      await loadBijoux();
    } catch (error) {
      console.error('Erreur création bijou:', error);
      alert('Erreur lors de la création du bijou');
    } finally {
      setSaving(false);
    }
  };

  const handleEditBijou = (bijou) => {
    setEditingBijou({
      ...bijou,
      poids: bijou.poids || '',
      prix_achat: bijou.prix_achat || '',
      prix_vente: bijou.prix_vente || '',
      description: bijou.description || '',
      dimensions: bijou.dimensions || '',
      pierres: bijou.pierres || '',
      certificat: bijou.certificat || '',
      stock_minimum: bijou.stock_minimum || 5,
      image_url: bijou.image_url || ''
    });
    
    // Construire l'URL complète pour le preview
    let previewUrl = null;
    if (bijou.image_url) {
      previewUrl = bijou.image_url.startsWith('/') 
        ? `${API_URL.replace("/api","")}${bijou.image_url}`
        : bijou.image_url;
    }
    setImagePreview(previewUrl);
    setShowEditModal(true);
    // Charger les fichiers existants du bijou
    fetch(`${API_URL}/bijoux-images/bijou/${bijou.id}/fichiers`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.ok ? r.json() : [])
      .then(d => setBijouFichiers(Array.isArray(d) ? d : []))
      .catch(() => setBijouFichiers([]));
  };

  const handleUpdateBijou = async () => {
    setSaving(true);
    try {
      let imageUrl = editingBijou.image_url;
      
      // Uploader l'image principale si sélectionnée
      if (imageFile) {
        const formData = new FormData();
        formData.append('image', imageFile);
        formData.append('type_creation', editingBijou.collection_nom ? 'BIJOUTERIE' : 'CLIENT');
        formData.append('type_bijou', editingBijou.categorie || 'bijou');
        formData.append('collection_nom', editingBijou.collection_nom || '');
        formData.append('bijou_id', editingBijou.id);
        formData.append('reference', editingBijou.reference || '');
        
        const uploadResponse = await fetch(`${API_URL}/bijoux-images/upload`, {
          method: 'POST',
          body: formData
        });
        
        if (uploadResponse.ok) {
          const data = await uploadResponse.json();
          imageUrl = data.url;
          
          // Ajouter à la galerie comme image principale
          await fetch(`${API_URL}/bijoux/${editingBijou.id}/images`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              image_url: data.url,
              est_principale: true,
              ordre_affichage: 0
            })
          });
        }
      }
      
      // Uploader les images supplémentaires
      if (bijouPhotos.length > 0) {
        for (let i = 0; i < bijouPhotos.length; i++) {
          const formData = new FormData();
          formData.append('image', bijouPhotos[i]);
          formData.append('type_creation', editingBijou.collection_nom ? 'BIJOUTERIE' : 'CLIENT');
          formData.append('type_bijou', editingBijou.categorie || 'bijou');
          formData.append('collection_nom', editingBijou.collection_nom || '');
          formData.append('bijou_id', editingBijou.id);
          formData.append('reference', editingBijou.reference || '');
          
          const uploadResponse = await fetch(`${API_URL}/bijoux-images/upload`, {
            method: 'POST',
            body: formData
          });
          
          if (uploadResponse.ok) {
            const data = await uploadResponse.json();
            
            // Ajouter à la galerie
            await fetch(`${API_URL}/bijoux/${editingBijou.id}/images`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                image_url: data.url,
                est_principale: false,
                ordre_affichage: i + 1
              })
            });
          }
        }
      }

      // Mettre à jour le bijou
      await bijouxAPI.update(editingBijou.id, {
        ...editingBijou,
        image_url: imageUrl,
        poids: editingBijou.poids ? parseFloat(editingBijou.poids) : null,
        prix_achat: parseFloat(editingBijou.prix_achat) || 0,
        prix_vente: parseFloat(editingBijou.prix_vente) || 0,
        stock_minimum: parseInt(editingBijou.stock_minimum) || 5
      });

      // Réinitialiser et recharger
      setShowEditModal(false);
      setEditingBijou(null);
      setImageFile(null);
      setImagePreview(null);
      setBijouPhotos([]);
      setPhotosPreviews([]);
      await loadBijoux();
    } catch (error) {
      console.error('Erreur modification bijou:', error);
      alert('Erreur lors de la modification du bijou');
    } finally {
      setSaving(false);
    }
  };

  // Badge statut basé sur statut_fabrication (prioritaire) puis inventaire_actif
  const getStatutBadge = (bijou) => {
    if (bijou.statut_fabrication === 'en_fabrication') {
      return { label: 'En fabrication', cls: 'bg-amber-100 text-amber-700 border border-amber-200', Icon: Clock };
    }
    if (bijou.inventaire_actif) {
      return { label: 'En stock', cls: 'bg-green-100 text-green-700 border border-green-200', Icon: CheckCircle };
    }
    if (bijou.statut_fabrication === 'termine' || bijou.statut_fabrication === 'valide') {
      return { label: 'Terminé atelier', cls: 'bg-blue-100 text-blue-700 border border-blue-200', Icon: Package };
    }
    return { label: 'Vendu', cls: 'bg-gray-100 text-gray-600 border border-gray-200', Icon: null };
  };

  const getStockBadgeColor = (stock) => {
    if (stock === 0) return 'bg-red-100 text-red-800 border border-red-200';
    if (stock < 5) return 'bg-orange-100 text-orange-800 border border-orange-200';
    if (stock < 10) return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
    return 'bg-green-100 text-green-800 border border-green-200';
  };


  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement des bijoux...</p>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="space-y-6">
      {/* Toggle Catalogue / Pièces */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        {!isVendeuse && <div className="flex rounded-lg border border-gray-300 overflow-hidden">
          <button onClick={() => setVueMode('catalogue')}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors ${vueMode === 'catalogue' ? 'bg-purple-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
            Catalogue
          </button>
          <button onClick={() => setVueMode('liste')}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors border-l border-gray-300 ${vueMode === 'liste' ? 'bg-purple-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
            Pieces &amp; Production
          </button>
          <button onClick={() => setVueMode('production')}
            className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium transition-colors border-l border-gray-300 ${vueMode === 'production' ? 'bg-amber-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>
            <Clock className="h-4 w-4" />
            Productions en cours
          </button>
        </div>}
        {!isVendeuse && <div className="flex gap-2">
          {/* §98 - Export Excel stock bijoux */}
          <button
            onClick={async () => {
              try {
                const res = await fetch(`${API_URL}/exports/stock-bijoux`, {
                  headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
                });
                if (!res.ok) throw new Error('Export failed: ' + res.status);
                const blob = await res.blob();
                const cd = res.headers.get('Content-Disposition') || '';
                const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/);
                const fname = m ? decodeURIComponent(m[1]) : 'Stock_Bijoux.xlsx';
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url; a.download = fname;
                document.body.appendChild(a); a.click();
                a.remove(); window.URL.revokeObjectURL(url);
              } catch (e) {
                alert('Erreur export Excel : ' + e.message);
              }
            }}
            className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-green-600 text-white rounded-lg cursor-pointer hover:bg-green-700 transition-colors w-full sm:w-auto justify-center"
            title="Télécharger Excel"
          >
            📊 Exporter Excel
          </button>
          <label className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-amber-600 text-white rounded-lg cursor-pointer hover:bg-amber-700 transition-colors w-full sm:w-auto justify-center">
            <Upload className="h-4 w-4" />
            Import images
            <input type="file" multiple accept="image/*" className="hidden" onChange={async (e) => {
              const files = e.target.files;
              if (!files.length) return;
              const formData = new FormData();
              for (let f of files) formData.append('images', f);
              try {
                const res = await fetch(`${API_URL}/bijoux-images/import-masse`, {
                  method: 'POST',
                  body: formData
                });
                const data = await res.json();
                let msg = `${data.associees || 0} images associees sur ${data.total || 0}`;
                if (data.non_trouvees?.length) msg += `\n\nNon trouvees:\n${data.non_trouvees.join('\n')}`;
                if (data.erreurs?.length) msg += `\n\nErreurs:\n${data.erreurs.join('\n')}`;
                alert(msg);
                loadBijoux();
              } catch (err) {
                alert('Erreur import: ' + err.message);
              }
              e.target.value = '';
            }} />
          </label>
        </div>}
      </div>

      {/* Vue Catalogue */}
      {vueMode === 'catalogue' && <CatalogueBijoux
        onOuvrirFicheFab={ouvrirFicheFab}
        onLancerProduction={ajouterAuPanier}
        onVoirPieces={(ref) => { setSearchTerm(ref); setVueMode('liste'); }}
      />}

      {/* Vue Pièces + Panier production (liste = stock, production = en fabrication) */}
      {(vueMode === 'liste' || vueMode === 'production') && <>
        {/* Barre de recherche Pièces */}
        <div className="flex gap-2 items-center">
          <div className="relative flex-1">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">🔍</span>
            <input
              type="text"
              placeholder="Chercher par référence, nom, numéro 1.XXXX..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 focus:border-transparent bg-white shadow-sm"
            />
          </div>
          {searchTerm && (
            <button onClick={() => setSearchTerm('')} className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              ✕ Effacer
            </button>
          )}
          {vueMode === 'liste' && (
            <label className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 bg-white border border-gray-300 rounded-lg cursor-pointer hover:bg-gray-50 whitespace-nowrap">
              <input
                type="checkbox"
                checked={inclureVendus}
                onChange={e => setInclureVendus(e.target.checked)}
                className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-400"
              />
              Inclure vendus
            </label>
          )}
        </div>

        {/* Compteur + totaux dynamiques — suivent recherche/vue/inclure-vendus (meme jeu que la liste) */}
        {(() => {
          const enStock = filteredBijoux.filter(b => b.inventaire_actif);
          const vendues = filteredBijoux.length - enStock.length;
          const valeurPvp = enStock.reduce((t, b) => t + parseFloat(b.pvp_magasin || b.prix_vente || 0), 0);
          return (
            <p className="text-sm text-gray-500 mb-3">
              <span className="font-semibold text-gray-700">{filteredBijoux.length}</span> piece{filteredBijoux.length > 1 ? 's' : ''}
              {' '}({enStock.length} en stock{vendues > 0 ? ` · ${vendues} vendue${vendues > 1 ? 's' : ''}` : ''})
              {' '}· Valeur stock (PVP) : <span className="font-bold text-gray-700">{valeurPvp.toLocaleString('fr-FR')} DH</span>
            </p>
          );
        })()}

        {/* Mobile cards - hidden on desktop */}
        <div className="md:hidden space-y-3">
          {filteredBijoux.length === 0 ? (
            <div className="bg-white rounded-lg shadow p-8 text-center">
              <AlertCircle className="h-10 w-10 mx-auto mb-3 text-gray-400" />
              <p className="text-gray-500 font-medium">{vueMode === 'production' ? 'Aucune production en cours' : 'Aucun bijou trouvé'}</p>
            </div>
          ) : filteredBijoux.map(bijou => (
            <div key={bijou.id} className="bg-white rounded-lg shadow p-4 border-l-4 border-amber-400">
              <div className="flex justify-between items-start mb-2">
                <div className="min-w-0 flex-1 mr-2">
                  <div className="font-bold font-mono text-gray-900 text-sm">
                    {bijou.reference_article || bijou.ref_article || bijou.id_produit || '—'}
                  </div>
                  <div className="text-sm text-gray-500 mt-0.5">
                    {bijou.categorie && <span className="capitalize">{bijou.categorie}</span>}
                    {bijou.couleur_or && <span> · Or {bijou.couleur_or.toLowerCase()}</span>}
                  </div>
                  {(bijou.nom || bijou.description) && (
                    <div className="text-xs text-gray-400 mt-0.5 truncate">
                      {bijou.nom || bijou.description}
                    </div>
                  )}
                </div>
                {(() => {
                  const badge = getStatutBadge(bijou);
                  return (
                    <span className={`flex-shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${badge.cls}`}>
                      {badge.Icon && <badge.Icon className="h-3 w-3" />}
                      {badge.label}
                    </span>
                  );
                })()}
              </div>
              <div className="flex justify-between items-center">
                <div className="font-bold text-amber-600">
                  {(bijou.pvp_magasin || bijou.prix_vente)
                    ? `${parseFloat(bijou.pvp_magasin || bijou.prix_vente).toLocaleString('fr-FR')} DH`
                    : '—'}
                </div>
                <button
                  onClick={() => handleViewDetails(bijou)}
                  className="px-3 py-1.5 bg-amber-600 text-white rounded-lg text-sm font-semibold"
                >
                  Voir détails
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop table - hidden on mobile */}
        <div className="hidden md:block bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Image
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Référence
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Désignation &amp; Détails
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Pierres
                </th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Prix
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Localisation
                </th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Statut
                </th>
                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap sticky right-0 z-20 bg-gray-100 shadow-[-8px_0_8px_-6px_rgba(0,0,0,0.15)]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredBijoux.length === 0 ? (
                <tr>
                  <td colSpan="8" className="px-6 py-12 text-center">
                    <div className="flex flex-col items-center justify-center text-gray-500">
                      <AlertCircle className="h-12 w-12 mb-3 text-gray-400" />
                      <p className="text-lg font-medium">{vueMode === 'production' ? 'Aucune production en cours' : 'Aucun bijou trouvé'}</p>
                      <p className="text-sm">{vueMode === 'production' ? 'Les pièces en fabrication apparaîtront ici' : 'Essayez de modifier vos critères de recherche'}</p>
                    </div>
                  </td>
                </tr>
              ) : (
                filteredBijoux.map((bijou) => (
                  <tr 
                    key={bijou.id} 
                    onClick={() => handleViewDetails(bijou)}
                    className="hover:bg-blue-50 transition-colors cursor-pointer group"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="relative w-16 h-16 rounded-lg overflow-hidden bg-gray-100 border-2 border-gray-200 group-hover:border-blue-400 transition-colors">
                        {bijou.image_url ? (
                          <img 
                            src={bijou.image_url.startsWith('/') ? `${API_URL.replace("/api","")}${bijou.image_url}` : bijou.image_url} 
                            alt={bijou.nom}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div 
                          className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-purple-100 to-blue-100"
                          style={{ display: bijou.image_url ? 'none' : 'flex' }}
                        >
                          <Gem className="h-8 w-8 text-purple-400" />
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap min-w-[130px]">
                      {/* Référence complète : BAGB21 · 1.1361 */}
                      {(bijou.reference_article || bijou.ref_article) ? (
                        <>
                          <button
                            onClick={(e) => { e.stopPropagation(); ouvrirFicheFab(bijou.id); }}
                            className="font-mono font-bold text-sm text-purple-700 bg-purple-50 hover:bg-purple-200 px-2 py-1 rounded inline-block cursor-pointer transition-colors border border-transparent hover:border-purple-300"
                            title="Ouvrir la fiche fabrication"
                          >
                            {bijou.reference_article || bijou.ref_article}
                          </button>
                          {bijou.id_produit && (
                            <div className="font-mono text-xs text-gray-500 mt-0.5 pl-0.5">{bijou.id_produit}</div>
                          )}
                        </>
                      ) : (
                        <div className="font-mono text-xs text-gray-400">{bijou.id_produit || bijou.reference || '—'}</div>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      {/* Désignation libre — ne jamais afficher la reference_article ici */}
                      <div className="text-sm font-medium text-gray-900 group-hover:text-blue-600">
                        {(() => {
                          const ref = bijou.reference_article || bijou.ref_article || '';
                          const nom = bijou.nom || '';
                          const desc = bijou.description || '';
                          // Si le nom ressemble à la référence ou est vide, afficher la description
                          const designation = (nom && nom.toUpperCase() !== ref.toUpperCase()) ? nom : desc;
                          return designation || <span className="text-gray-400 italic">—</span>;
                        })()}
                      </div>
                      <div className="flex items-center gap-1.5 mt-1 flex-wrap">
                        {bijou.categorie && (
                          <span className="text-xs px-1.5 py-0.5 rounded-full bg-purple-100 text-purple-700 font-medium capitalize">{bijou.categorie}</span>
                        )}
                        {bijou.couleur_or && (
                          <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${
                            bijou.couleur_or === 'BLANC' ? 'bg-gray-100 text-gray-600 border border-gray-300' :
                            bijou.couleur_or === 'ROSE'  ? 'bg-pink-100 text-pink-700' :
                            'bg-yellow-100 text-yellow-700'
                          }`}>Or {(bijou.couleur_or || '').toLowerCase()} 18k</span>
                        )}
                        {bijou.collection_nom && (
                          <span className="text-xs text-indigo-600 font-medium">{bijou.collection_nom}</span>
                        )}
                        {(bijou.poids_metal || bijou.poids_brut) && (
                          <span className="text-xs text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded-full">
                            {bijou.poids_metal || bijou.poids_brut} g
                          </span>
                        )}
                      </div>
                      {/* Description (seulement si différente du nom affiché) */}
                      {bijou.description && bijou.nom && bijou.description !== bijou.nom
                        && bijou.description !== bijou.id_produit
                        && bijou.description.toUpperCase() !== (bijou.reference_article || '').toUpperCase() && (
                        <p className="text-xs text-gray-400 mt-1 max-w-xs truncate">{bijou.description}</p>
                      )}
                      {/* Certificat */}
                      {bijou.certificat && (
                        <div className="flex items-center gap-1 mt-1">
                          <span className="text-xs bg-green-50 text-green-700 border border-green-200 px-1.5 py-0.5 rounded-full">
                            📜 {bijou.certificat}
                          </span>
                        </div>
                      )}
                    </td>
                    {/* Pierres */}
                    <td className="px-4 py-3">
                      {bijou.nbre_pierre_total > 0 ? (
                        <div className="space-y-1">
                          <div className="flex items-center gap-1.5">
                            <span className="text-base">💎</span>
                            <span className="text-sm font-bold text-blue-700">{bijou.nbre_pierre_total}</span>
                            <span className="text-xs text-gray-500">pierre{bijou.nbre_pierre_total > 1 ? 's' : ''}</span>
                          </div>
                          {bijou.poids_pierre_total > 0 && (
                            <div className="text-xs text-indigo-600 font-medium">{parseFloat(bijou.poids_pierre_total).toFixed(2)} ct</div>
                          )}
                          {bijou.pierres_desc && (
                            <div className="text-xs text-gray-500 max-w-[140px] truncate" title={bijou.pierres_desc}>{bijou.pierres_desc}</div>
                          )}
                        </div>
                      ) : (
                        <span className="text-xs text-gray-300">—</span>
                      )}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-right">
                      <div className="text-sm font-bold text-gray-900">
                        {parseFloat(bijou.pvp_magasin || bijou.prix_vente || 0).toLocaleString('fr-FR')} DH
                      </div>
                      {!isVendeuse && (bijou.prix_base || bijou.prix_achat) > 0 && (
                        <div className="text-xs text-gray-400">
                          Revient: {parseFloat(bijou.prix_base || bijou.prix_achat).toLocaleString('fr-FR')} DH
                        </div>
                      )}
                    </td>
                    {/* Localisation */}
                    <td className="px-4 py-3">
                      {bijou.inventaire_actif ? (
                        <div className="flex items-center gap-1 text-xs text-blue-600">
                          <MapPin className="h-3 w-3 flex-shrink-0" />
                          <span>{bijou.boutique_nom || 'Stock central'}</span>
                        </div>
                      ) : (
                        bijou.client_acheteur ? (
                          <div className="flex items-center gap-1 text-xs text-purple-600">
                            <ShoppingCart className="h-3 w-3 flex-shrink-0" />
                            <span className="truncate max-w-[110px]" title={bijou.client_acheteur}>{bijou.client_acheteur}</span>
                          </div>
                        ) : (
                          <span className="text-xs text-gray-300">—</span>
                        )
                      )}
                    </td>
                    {/* Statut — basé sur statut_fabrication puis inventaire_actif */}
                    <td className="px-4 py-3 whitespace-nowrap text-center">
                      {(() => {
                        const badge = getStatutBadge(bijou);
                        return (
                          <div>
                            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold ${badge.cls}`}>
                              {badge.Icon && <badge.Icon className="h-3 w-3" />}
                              {badge.label}
                            </span>
                            {badge.label === 'Vendu' && bijou.date_vente && (
                              <div className="text-xs text-gray-400 mt-0.5">
                                {new Date(bijou.date_vente).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })}
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center sticky right-0 z-10 bg-white group-hover:bg-blue-50 shadow-[-8px_0_8px_-6px_rgba(0,0,0,0.15)]">
                      <div className="flex items-center justify-center space-x-2">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewDetails(bijou);
                          }}
                          className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg transition-colors"
                          title="Voir détails et traçabilité"
                        >
                          <Eye className="h-5 w-5" />
                        </button>
                        {/* §202 — actions production/mutation masquées pour la vendeuse */}
                        {!isVendeuse && (<>
                        {(bijou._statut_fabrication === 'en_fabrication' || bijou._statut_fabrication === 'termine' || bijou.statut_fabrication === 'en_fabrication' || bijou.statut_fabrication === 'termine') && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setHistoriqueBijouId(bijou.id);
                              setShowHistoriqueModal(true);
                            }}
                            className="p-2 rounded-lg transition-colors"
                            style={{ color: '#d4af37' }}
                            title="Historique production"
                          >
                            <History className="h-5 w-5" />
                          </button>
                        )}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            ajouterAuPanier(bijou);
                          }}
                          className={`p-2 rounded-lg transition-colors ${
                            panier.find(i => i.reference_article === (bijou.reference_article || bijou.reference))
                              ? 'text-green-700 bg-green-100'
                              : 'text-green-600 hover:bg-green-100'
                          }`}
                          title="Ajouter au panier de production"
                        >
                          <Play className="h-5 w-5 fill-current" />
                        </button>
                        {bijou.inventaire_actif ? (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditPrix({ bijou, prix: bijou.pvp_magasin || bijou.prix_vente || '' });
                            }}
                            className="p-2 text-amber-600 hover:bg-amber-100 rounded-lg transition-colors font-bold text-base leading-none"
                            title="Modifier le prix de vente"
                          >
                            €
                          </button>
                        ) : null}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditBijou(bijou);
                          }}
                          className="p-2 text-green-600 hover:bg-green-100 rounded-lg transition-colors"
                          title="Modifier"
                        >
                          <Edit className="h-5 w-5" />
                        </button>
                        <button
                          onClick={(e) => e.stopPropagation()}
                          className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition-colors"
                          title="Supprimer"
                        >
                          <Trash2 className="h-5 w-5" />
                        </button>
                        </>)}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      </>}

      {/* Mini-modal édition prix (manuel, tracé) */}
      {editPrix && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setEditPrix(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6" onClick={e => e.stopPropagation()}>
            <h3 className="font-bold text-gray-800 mb-1">Modifier le prix de vente</h3>
            <p className="text-sm text-gray-500 mb-3">{editPrix.bijou.id_produit || editPrix.bijou.reference} · {editPrix.bijou.nom}</p>
            <div className="bg-gray-50 rounded-lg p-3 text-sm flex justify-between mb-3">
              <span className="text-gray-500">Prix actuel</span>
              <span className="font-semibold">{Number(editPrix.bijou.pvp_magasin || editPrix.bijou.prix_vente || 0).toLocaleString('fr-FR')} DH</span>
            </div>
            <label className="text-xs font-semibold text-gray-600 block mb-1">Nouveau prix (DH)</label>
            <input type="number" step="0.01" autoFocus value={editPrix.prix}
                   onChange={e => setEditPrix(p => ({ ...p, prix: e.target.value }))}
                   onKeyDown={e => e.key === 'Enter' && parseFloat(editPrix.prix) > 0 && sauverPrix()}
                   className="w-full border border-gray-300 rounded-lg px-3 py-2 text-lg font-bold mb-4" />
            <div className="flex justify-end gap-2">
              <button onClick={() => setEditPrix(null)} className="px-4 py-2 border border-gray-300 rounded-lg text-sm">Annuler</button>
              <button onClick={sauverPrix} disabled={!(parseFloat(editPrix.prix) > 0)}
                      className="px-4 py-2 bg-amber-600 text-white rounded-lg text-sm font-semibold disabled:opacity-40">Enregistrer</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de détails et traçabilité */}
      {showDetailModal && selectedBijou && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl max-w-6xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            {/* En-tête du modal avec image */}
            {/* ── En-tête luxe ── */}
            <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white px-8 py-6 rounded-t-lg">
              <div className="flex gap-6 items-start">
                {/* Image grande */}
                <div className="relative w-40 h-40 rounded-2xl overflow-hidden bg-white bg-opacity-10 border border-white border-opacity-20 flex-shrink-0 shadow-2xl">
                  {selectedBijou.image_url ? (
                    <img
                      src={selectedBijou.image_url.startsWith('/') ? `${API_URL.replace("/api","")}${selectedBijou.image_url}` : selectedBijou.image_url}
                      alt={selectedBijou.nom}
                      className="w-full h-full object-cover"
                      onError={(e) => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }}
                    />
                  ) : null}
                  <div className="absolute inset-0 flex items-center justify-center" style={{ display: selectedBijou.image_url ? 'none' : 'flex' }}>
                    <Gem className="h-16 w-16 text-amber-400 opacity-60" />
                  </div>
                </div>
                {/* Infos principales */}
                <div className="flex-1 min-w-0">
                  {/* Collection */}
                  {selectedBijou.collection_nom && (
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-amber-400 text-xs">✦</span>
                      <span className="text-amber-400 text-xs font-bold uppercase tracking-[0.2em]">{selectedBijou.collection_nom}</span>
                    </div>
                  )}
                  {/* Référence */}
                  <div className="text-gray-500 text-xs font-mono mb-1">
                    {selectedBijou.reference_article || selectedBijou.id_produit || selectedBijou.reference}
                  </div>
                  {/* Nom */}
                  <h3 className="text-2xl font-bold text-white leading-tight mb-3">
                    {selectedBijou.nom || selectedBijou.description}
                  </h3>
                  {/* Badges */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {selectedBijou.couleur_or && (
                      <span className={`text-xs px-3 py-1 rounded-full font-semibold ${
                        selectedBijou.couleur_or === 'BLANC' ? 'bg-gray-300 text-gray-800' :
                        selectedBijou.couleur_or === 'ROSE'  ? 'bg-pink-300 text-pink-900' :
                                                                'bg-yellow-300 text-yellow-900'
                      }`}>
                        Or {selectedBijou.couleur_or.charAt(0) + selectedBijou.couleur_or.slice(1).toLowerCase()} 18k
                      </span>
                    )}
                    {selectedBijou.categorie && (
                      <span className="text-xs px-3 py-1 rounded-full bg-white bg-opacity-15 text-white font-medium capitalize border border-white border-opacity-20">
                        {selectedBijou.categorie}
                      </span>
                    )}
                    {selectedBijou.inventaire_actif ? (
                      <span className="text-xs px-3 py-1 rounded-full bg-green-500 bg-opacity-90 text-white font-semibold">✓ Disponible</span>
                    ) : (
                      <span className="text-xs px-3 py-1 rounded-full bg-red-500 bg-opacity-90 text-white font-semibold">Vendue</span>
                    )}
                  </div>
                  {/* Prix */}
                  <div>
                    <div className="text-gray-500 text-xs uppercase tracking-widest mb-0.5">Prix de vente conseille</div>
                    <div className="text-4xl font-bold text-amber-400 leading-none">
                      {parseFloat(selectedBijou.pvp_magasin || selectedBijou.prix_vente || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} <span className="text-2xl">DH</span>
                    </div>
                    {!isVendeuse && <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-xs">
                      {parseFloat(selectedBijou.cout_reel_total || 0) > 0 && (
                        <span className="text-gray-400">Cout reel: <span className="text-white font-semibold">{parseFloat(selectedBijou.cout_reel_total).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span></span>
                      )}
                      {parseFloat(selectedBijou.cout_metal || selectedBijou.cout_reel_metal || 0) > 0 && (
                        <span className="text-gray-400">Metal: <span className="text-yellow-300 font-semibold">{parseFloat(selectedBijou.cout_metal || selectedBijou.cout_reel_metal).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span></span>
                      )}
                      {parseFloat(selectedBijou.cout_pierres || 0) > 0 && (
                        <span className="text-gray-400">Pierres: <span className="text-blue-300 font-semibold">{parseFloat(selectedBijou.cout_pierres).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span></span>
                      )}
                      {parseFloat(selectedBijou.cout_main_oeuvre || selectedBijou.cout_reel_main_oeuvre || 0) > 0 && (
                        <span className="text-gray-400">Main d'oeuvre: <span className="text-green-300 font-semibold">{parseFloat(selectedBijou.cout_main_oeuvre || selectedBijou.cout_reel_main_oeuvre).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span></span>
                      )}
                      {parseFloat(selectedBijou.prix_theorique || 0) > 0 && (
                        <span className="text-gray-400">Prix devis: <span className="text-purple-300 font-semibold">{parseFloat(selectedBijou.prix_theorique).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span></span>
                      )}
                      {selectedBijou.coefficient_marge && parseFloat(selectedBijou.coefficient_marge) > 0 && (
                        <span className="text-gray-400">Coeff. marge: <span className="text-orange-300 font-semibold">x{parseFloat(selectedBijou.coefficient_marge).toFixed(2)}</span></span>
                      )}
                    </div>}
                    {!selectedBijou.inventaire_actif && selectedBijou.date_vente && (
                      <div className="mt-2 px-3 py-1.5 rounded-lg bg-red-500 bg-opacity-20 border border-red-400 border-opacity-30 text-xs">
                        <span className="text-red-300">Vendu le {new Date(selectedBijou.date_vente).toLocaleDateString('fr-FR')} a </span>
                        <span className="text-white font-bold">{parseFloat(selectedBijou.prix_vente || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH</span>
                      </div>
                    )}
                  </div>
                </div>
                {/* Fermer */}
                <button
                  onClick={() => { setShowDetailModal(false); setSelectedBijou(null); setTraceData(null); }}
                  className="text-gray-500 hover:text-white hover:bg-white hover:bg-opacity-10 rounded-lg p-2 transition-colors flex-shrink-0"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            {/* Contenu du modal */}
            <div className="flex-1 overflow-y-auto p-6">
              {/* Palier A' — Analyse cout (loading independant de loadingTrace) */}
              {/* §202 — coût/marge jamais visible pour la vendeuse */}
              {!isVendeuse && (
                <div className="mb-2">
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">Coût &amp; marge réelle</p>
                  <CoutDetailBlock bijouId={selectedBijou.id} />
                </div>
              )}
              {/* Fiche de calcul barémée PR/PVP (moteur) — composant partagé avec le Catalogue */}
              {!isVendeuse && (
                <div className="mb-6 border border-gray-200 rounded-xl p-4">
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">💰 Fiche de calcul (PR/PVP)</p>
                  <FicheCalculMoteur
                    bijouId={selectedBijou.id}
                    prixFige={selectedBijou.pvp_magasin || selectedBijou.prix_vente || selectedBijou.prix_base}
                  />
                </div>
              )}
              {loadingTrace ? (
                <div className="flex items-center justify-center h-64">
                  <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Chargement de la traçabilité...</p>
                  </div>
                </div>
              ) : traceData ? (
                <div className="space-y-6">
                  {/* ── FICHE PRODUIT LUXE ── */}
                  <div className="space-y-4">
                    {/* Composition */}
                    <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-5 border border-amber-200 shadow-sm">
                      <h5 className="text-xs font-bold text-amber-800 uppercase tracking-[0.15em] mb-3 flex items-center gap-2">
                        <span className="text-base">🥇</span> Composition
                      </h5>
                      <div className="flex flex-wrap gap-2">
                        {traceData.bijou.couleur_or && (
                          <span className={`px-4 py-2 rounded-full text-sm font-semibold ${
                            traceData.bijou.couleur_or === 'BLANC' ? 'bg-gray-200 text-gray-800' :
                            traceData.bijou.couleur_or === 'ROSE'  ? 'bg-pink-200 text-pink-900' :
                                                                      'bg-yellow-200 text-yellow-900'
                          }`}>
                            Or {traceData.bijou.couleur_or.charAt(0) + traceData.bijou.couleur_or.slice(1).toLowerCase()} 18k
                          </span>
                        )}
                        {(traceData.bijou.poids_metal || traceData.bijou.poids) && (
                          <span className="px-4 py-2 rounded-full text-sm font-medium bg-white text-amber-800 border border-amber-300">
                            {traceData.bijou.poids_metal || traceData.bijou.poids} g métal net
                          </span>
                        )}
                        {traceData.bijou.poids_brut && parseFloat(traceData.bijou.poids_brut) > 0 && (
                          <span className="px-4 py-2 rounded-full text-sm font-medium bg-white text-amber-700 border border-amber-200">
                            {traceData.bijou.poids_brut} g brut
                          </span>
                        )}
                        {!traceData.bijou.couleur_or && !traceData.bijou.poids_metal && !traceData.bijou.poids && (
                          <span className="text-sm text-gray-400 italic">Composition non renseignée</span>
                        )}
                      </div>
                    </div>

                    {/* Prix & Couts detailles — §202 masqué pour la vendeuse */}
                    {!isVendeuse && (
                    <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-5 border border-amber-200 shadow-sm">
                      <h5 className="text-xs font-bold text-amber-800 uppercase tracking-[0.15em] mb-3 flex items-center gap-2">
                        <span className="text-base">💰</span> Prix & Couts
                      </h5>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                        {[
                          { label: 'PVP Boutique', value: selectedBijou.pvp_magasin, color: 'text-green-700', bg: 'bg-green-50 border-green-200' },
                          { label: 'Prix catalogue', value: selectedBijou.prix_vente, color: 'text-blue-700', bg: 'bg-blue-50 border-blue-200' },
                          { label: 'Prix devis', value: selectedBijou.prix_theorique, color: 'text-purple-700', bg: 'bg-purple-50 border-purple-200' },
                          { label: 'Cout reel total', value: selectedBijou.cout_reel_total, color: 'text-red-700', bg: 'bg-red-50 border-red-200' },
                          { label: 'Cout metal', value: selectedBijou.cout_metal || selectedBijou.cout_reel_metal, color: 'text-yellow-700', bg: 'bg-yellow-50 border-yellow-200' },
                          { label: 'Cout pierres', value: selectedBijou.cout_pierres, color: 'text-blue-700', bg: 'bg-blue-50 border-blue-200' },
                          { label: 'Main d\'oeuvre', value: selectedBijou.cout_main_oeuvre || selectedBijou.cout_reel_main_oeuvre, color: 'text-green-700', bg: 'bg-green-50 border-green-200' },
                          { label: 'Prix fabrication', value: selectedBijou.prix_base, color: 'text-orange-700', bg: 'bg-orange-50 border-orange-200' },
                          { label: 'Coeff. marge', value: selectedBijou.coefficient_marge, isCoeff: true, color: 'text-gray-700', bg: 'bg-gray-50 border-gray-200' },
                        ].filter(item => parseFloat(item.value || 0) > 0).map((item, i) => (
                          <div key={i} className={`rounded-xl p-3 border ${item.bg}`}>
                            <p className="text-[10px] text-gray-500 uppercase font-medium">{item.label}</p>
                            <p className={`text-lg font-black ${item.color}`}>
                              {item.isCoeff ? `x${parseFloat(item.value).toFixed(2)}` : `${parseFloat(item.value).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH`}
                            </p>
                          </div>
                        ))}
                      </div>
                      {/* Marge si vendu */}
                      {!selectedBijou.inventaire_actif && parseFloat(selectedBijou.cout_reel_total || 0) > 0 && (
                        <div className="mt-3 p-3 rounded-xl bg-white border border-amber-200 flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-600">Marge realisee</span>
                          <span className={`text-lg font-black ${(parseFloat(selectedBijou.prix_vente || 0) - parseFloat(selectedBijou.cout_reel_total || 0)) >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                            {(parseFloat(selectedBijou.prix_vente || 0) - parseFloat(selectedBijou.cout_reel_total || 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} DH
                          </span>
                        </div>
                      )}
                    </div>
                    )}

                    {/* Pierres (si présentes) */}
                    {(parseFloat(traceData.bijou.nbre_pierre_total) > 0 || parseFloat(traceData.bijou.poids_pierre_total || traceData.bijou.poids_pierres_carats) > 0 || traceData.bijou.pierres || traceData.bijou.of_pierres_desc) && (
                      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-5 border border-blue-200 shadow-sm">
                        <h5 className="text-xs font-bold text-blue-800 uppercase tracking-[0.15em] mb-3 flex items-center gap-2">
                          <span className="text-base">💎</span> Pierres
                        </h5>
                        <div className="flex flex-wrap gap-3 items-center">
                          {parseFloat(traceData.bijou.nbre_pierre_total) > 0 && (
                            <div className="flex flex-col items-center bg-white rounded-xl px-5 py-3 border border-blue-200 shadow-sm">
                              <span className="text-2xl font-bold text-blue-700">{traceData.bijou.nbre_pierre_total}</span>
                              <span className="text-xs text-gray-500 mt-0.5">pierre{traceData.bijou.nbre_pierre_total > 1 ? 's' : ''}</span>
                            </div>
                          )}
                          {parseFloat(traceData.bijou.poids_pierre_total || traceData.bijou.poids_pierres_carats) > 0 && (
                            <div className="flex flex-col items-center bg-white rounded-xl px-5 py-3 border border-blue-200 shadow-sm">
                              <span className="text-2xl font-bold text-indigo-700">{parseFloat(traceData.bijou.poids_pierre_total || traceData.bijou.poids_pierres_carats).toFixed(2)}</span>
                              <span className="text-xs text-gray-500 mt-0.5">carats</span>
                            </div>
                          )}
                          {(traceData.bijou.of_pierres_desc || traceData.bijou.pierres) && (
                            <span className="text-sm text-blue-800 font-medium">{traceData.bijou.of_pierres_desc || traceData.bijou.pierres}</span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Certificat */}
                    {traceData.bijou.certificat && (
                      <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-5 border border-green-200 shadow-sm">
                        <h5 className="text-xs font-bold text-green-800 uppercase tracking-[0.15em] mb-2 flex items-center gap-2">
                          <span className="text-base">📜</span> Certification
                        </h5>
                        <p className="text-sm text-green-900 font-medium">{traceData.bijou.certificat}</p>
                      </div>
                    )}

                    {/* Description */}
                    {traceData.bijou.description &&
                     traceData.bijou.description !== traceData.bijou.reference_article &&
                     traceData.bijou.description !== traceData.bijou.id_produit && (
                      <div className="bg-gray-50 rounded-2xl p-5 border border-gray-200 shadow-sm">
                        <h5 className="text-xs font-bold text-gray-600 uppercase tracking-[0.15em] mb-2 flex items-center gap-2">
                          <span className="text-base">📝</span> Description
                        </h5>
                        <p className="text-sm text-gray-700 leading-relaxed">{traceData.bijou.description}</p>
                      </div>
                    )}

                    {/* Stats du modèle + localisation */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Stats modèle */}
                      {traceData.stats_modele && (
                        <div className="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm">
                          <h5 className="text-xs font-bold text-gray-600 uppercase tracking-[0.15em] mb-4">Pièces du modèle</h5>
                          <div className="flex justify-around text-center">
                            <div>
                              <div className="text-3xl font-bold text-gray-800">{traceData.stats_modele.nb_total || 0}</div>
                              <div className="text-xs text-gray-500 mt-1">Fabriquée{traceData.stats_modele.nb_total > 1 ? 's' : ''}</div>
                            </div>
                            <div className="w-px bg-gray-200"/>
                            <div>
                              <div className="text-3xl font-bold text-green-600">{traceData.stats_modele.nb_dispo || 0}</div>
                              <div className="text-xs text-gray-500 mt-1">Dispo</div>
                            </div>
                            <div className="w-px bg-gray-200"/>
                            <div>
                              <div className="text-3xl font-bold text-blue-600">{traceData.stats_modele.nb_vendus || 0}</div>
                              <div className="text-xs text-gray-500 mt-1">Vendue{traceData.stats_modele.nb_vendus > 1 ? 's' : ''}</div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Localisation de la pièce */}
                      <div className="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm">
                        <h5 className="text-xs font-bold text-gray-600 uppercase tracking-[0.15em] mb-4 flex items-center gap-2">
                          <MapPin className="h-4 w-4" /> Localisation
                        </h5>
                        {traceData.bijou.inventaire_actif ? (
                          <div className="flex items-center gap-3">
                            <span className="text-2xl">
                              {traceData.boutique_piece ? '🏪' : '🏢'}
                            </span>
                            <div>
                              <div className="font-semibold text-gray-800">
                                {traceData.boutique_piece ? traceData.boutique_piece.nom : 'Stock Central'}
                              </div>
                              <div className="text-xs text-gray-500 capitalize">
                                {traceData.boutique_piece?.type || 'central'}
                              </div>
                            </div>
                            <span className="ml-auto text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full font-semibold">En stock</span>
                          </div>
                        ) : (
                          <div className="flex items-center gap-3">
                            <span className="text-2xl">🛒</span>
                            <div>
                              <div className="font-semibold text-gray-800">Pièce vendue</div>
                              {traceData.bijou.client_acheteur && (
                                <div className="text-xs text-gray-500">Client: {traceData.bijou.client_acheteur}</div>
                              )}
                              {traceData.bijou.date_vente && (
                                <div className="text-xs text-gray-400">
                                  {new Date(traceData.bijou.date_vente).toLocaleDateString('fr-FR')}
                                </div>
                              )}
                            </div>
                            <span className="ml-auto text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-semibold">Vendue</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>


                  {/* Transferts en cours */}
                  {traceData.transferts_en_cours && traceData.transferts_en_cours.length > 0 && (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-700 mb-3 flex items-center">
                        <Clock className="h-5 w-5 mr-2 text-yellow-600" />
                        Transferts en Cours
                      </h4>
                      <div className="space-y-2">
                        {traceData.transferts_en_cours.map((transfert, idx) => (
                          <div key={idx} className="flex items-center justify-between p-3 bg-white rounded-lg">
                            <div className="flex items-center space-x-3">
                              <div className="text-sm">
                                <span className="font-medium">{transfert.source_nom}</span>
                                <span className="mx-2 text-gray-400">→</span>
                                <span className="font-medium">{transfert.destination_nom}</span>
                              </div>
                            </div>
                            <div className="flex items-center space-x-3">
                              <span className="text-sm font-medium">{transfert.quantite} unité(s)</span>
                              <span className={`px-2 py-1 text-xs rounded-full ${
                                transfert.statut === 'en_transit' ? 'bg-blue-100 text-blue-800' :
                                transfert.statut === 'valide' ? 'bg-green-100 text-green-800' :
                                'bg-yellow-100 text-yellow-800'
                              }`}>
                                {transfert.statut.replace('_', ' ')}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Historique des mouvements */}
                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <h4 className="font-semibold text-gray-700 mb-4 flex items-center">
                      <History className="h-5 w-5 mr-2 text-purple-600" />
                      Historique des Mouvements
                    </h4>
                    {traceData.mouvements && traceData.mouvements.length > 0 ? (
                      <div className="space-y-3 max-h-96 overflow-y-auto">
                        {traceData.mouvements.map((mvt, idx) => (
                          <div key={idx} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                            <div className={`p-2 rounded-lg ${
                              mvt.type_mouvement === 'entree' ? 'bg-green-100' :
                              mvt.type_mouvement === 'sortie' ? 'bg-red-100' :
                              mvt.type_mouvement === 'vente' ? 'bg-blue-100' :
                              mvt.type_mouvement === 'transfert' ? 'bg-purple-100' :
                              'bg-gray-100'
                            }`}>
                              {mvt.type_mouvement === 'entree' && <TrendingUp className="h-5 w-5 text-green-600" />}
                              {mvt.type_mouvement === 'sortie' && <Package className="h-5 w-5 text-red-600" />}
                              {mvt.type_mouvement === 'vente' && <ShoppingCart className="h-5 w-5 text-blue-600" />}
                              {mvt.type_mouvement === 'transfert' && <MapPin className="h-5 w-5 text-purple-600" />}
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center justify-between mb-1">
                                <span className="font-medium text-gray-900 capitalize">
                                  {mvt.type_mouvement.replace('_', ' ')}
                                </span>
                                <span className="text-xs text-gray-500">
                                  {new Date(mvt.date_mouvement).toLocaleDateString('fr-FR', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}
                                </span>
                              </div>
                              <div className="text-sm text-gray-600">
                                <div className="flex items-center space-x-2">
                                  <span className="font-medium">{mvt.boutique_nom}</span>
                                  <span className="text-gray-400">•</span>
                                  <span className={mvt.quantite > 0 ? 'text-green-600' : 'text-red-600'}>
                                    {mvt.quantite > 0 ? '+' : ''}{mvt.quantite} unité(s)
                                  </span>
                                </div>
                                {mvt.client_nom && (
                                  <div className="mt-1 flex items-center space-x-2 text-xs">
                                    <ShoppingCart className="h-3 w-3" />
                                    <span>Client: <span className="font-medium">{mvt.client_nom}</span></span>
                                    {mvt.prix_vente && (
                                      <>
                                        <span className="text-gray-400">•</span>
                                        <span className="font-medium text-green-600">
                                          {parseFloat(mvt.prix_vente).toLocaleString()} DH
                                        </span>
                                      </>
                                    )}
                                  </div>
                                )}
                                {mvt.utilisateur_nom && (
                                  <div className="text-xs text-gray-500 mt-1">
                                    Par: {mvt.utilisateur_nom}
                                  </div>
                                )}
                                {mvt.commentaire && (
                                  <div className="text-xs text-gray-500 mt-1 italic">
                                    {mvt.commentaire}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-8 text-gray-500">
                        <History className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                        <p>Aucun mouvement enregistré</p>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  <AlertCircle className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                  <p>Impossible de charger les données de traçabilité</p>
                </div>
              )}
            </div>

            {/* Footer modal */}
            <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 flex justify-end gap-2">
              {/* Chantier 4 : bouton Voir fiche OF (caché si bijou achat ou sans OF) */}
              {/* §205 : masqué à la vendeuse (la fiche OF expose coût/marge/étapes) */}
              {!isVendeuse && selectedBijou.ordre_fabrication_id && !selectedBijou.depot_id && (
                <button
                  onClick={() => setShowFicheOF(true)}
                  className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors flex items-center gap-2"
                  title="Voir la fiche OF complète avec étapes"
                >
                  <Eye className="h-4 w-4" /> Voir fiche OF
                </button>
              )}
              <button
                onClick={() => { setShowDetailModal(false); setSelectedBijou(null); setTraceData(null); }}
                className="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chantier 4 : Sub-modal Fiche OF — §205 : jamais pour la vendeuse */}
      {showFicheOF && selectedBijou && !isVendeuse && (
        <FicheBijouTermineModal
          bijou={selectedBijou}
          onClose={() => setShowFicheOF(false)}
          onRelancerSuccess={(newBijouId, newOfId, data) => {
            setShowFicheOF(false);
            setShowDetailModal(false);
            setSelectedBijou(null);
            setTraceData(null);
            // Toast léger via alert (Q2 brouillon éditable - navigation à finaliser selon routing)
            const numero = data?.numero_ordre || (data?.ordres_crees && data.ordres_crees[0]) || '';
            alert(`Production relancée. ${numero ? 'OF ' + numero + ' créé.' : ''} Aller dans Atelier pour éditer le brouillon.`);
            // Reload liste bijoux pour voir le nouveau
            if (typeof loadBijoux === 'function') loadBijoux();
          }}
        />
      )}

      {/* Modal de création de bijou */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl max-w-4xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-4 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <Plus className="h-6 w-6" />
                <h3 className="text-xl font-bold">Ajouter un nouveau bijou</h3>
              </div>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setImageFile(null);
                  setImagePreview(null);
                }}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Colonne gauche */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Référence *</label>
                    <input
                      type="text"
                      value={newBijou.reference}
                      onChange={(e) => setNewBijou({...newBijou, reference: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Ex: BJX-001"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                    <input
                      type="text"
                      value={newBijou.nom}
                      onChange={(e) => setNewBijou({...newBijou, nom: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Ex: Bague en or"
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Catégorie</label>
                      <select
                        value={newBijou.categorie}
                        onChange={(e) => setNewBijou({...newBijou, categorie: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="bague">Bague</option>
                        <option value="collier">Collier</option>
                        <option value="bracelet">Bracelet</option>
                        <option value="boucles_oreilles">Boucles d'oreilles</option>
                        <option value="pendentif">Pendentif</option>
                        <option value="montre">Montre</option>
                        <option value="autre">Autre</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Matière</label>
                      <select
                        value={newBijou.matiere}
                        onChange={(e) => setNewBijou({...newBijou, matiere: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="or">Or</option>
                        <option value="argent">Argent</option>
                        <option value="platine">Platine</option>
                        <option value="diamant">Diamant</option>
                        <option value="perle">Perle</option>
                        <option value="autre">Autre</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Poids (g)</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={newBijou.poids}
                        onChange={(e) => setNewBijou({...newBijou, poids: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Ex: 5.5"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Dimensions</label>
                      <input
                        type="text"
                        value={newBijou.dimensions}
                        onChange={(e) => setNewBijou({...newBijou, dimensions: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="Ex: 18mm"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Pierres</label>
                    <textarea
                      value={newBijou.pierres}
                      onChange={(e) => setNewBijou({...newBijou, pierres: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Ex: 1 diamant 0.5ct, 2 rubis"
                      rows="2"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Certificat</label>
                    <input
                      type="text"
                      value={newBijou.certificat}
                      onChange={(e) => setNewBijou({...newBijou, certificat: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Ex: GIA #123456"
                    />
                  </div>
                </div>

                {/* Colonne droite */}
                <div className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prix d'achat (DH) *</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={newBijou.prix_achat}
                        onChange={(e) => setNewBijou({...newBijou, prix_achat: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="0.00"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prix de vente (DH) *</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={newBijou.prix_vente}
                        onChange={(e) => setNewBijou({...newBijou, prix_vente: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                        placeholder="0.00"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Stock minimum</label>
                    <input
                      type="text" inputMode="decimal" onFocus={e => e.target.select()}
                      value={newBijou.stock_minimum}
                      onChange={(e) => setNewBijou({...newBijou, stock_minimum: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="5"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                    <textarea
                      value={newBijou.description}
                      onChange={(e) => setNewBijou({...newBijou, description: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Description détaillée du bijou..."
                      rows="3"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Collection <span className="text-gray-400 text-xs">(optionnel — classe l'image dans le bon dossier)</span>
                    </label>
                    <input
                      type="text"
                      value={newBijou.collection_nom}
                      onChange={(e) => setNewBijou({...newBijou, collection_nom: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Ex: Nasha, Client, Autre... (vide = classé par type)"
                    />
                    <p className="text-xs text-gray-400 mt-1">
                      {newBijou.collection_nom
                        ? `📁 Image → collections/${newBijou.categorie}/${newBijou.collection_nom}/`
                        : `📁 Image → clients/${newBijou.categorie}/`}
                    </p>
                  </div>

                  {/* Upload d'images multiples */}
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-3 flex items-center space-x-2">
                      <Gem className="h-5 w-5 text-purple-600" />
                      <span>Photos du bijou (plusieurs photos possibles)</span>
                    </label>
                    
                    <div className="space-y-4">
                      {/* Zone d'upload */}
                      <label className="flex flex-col items-center px-6 py-8 bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-dashed border-purple-300 rounded-xl cursor-pointer hover:border-purple-500 hover:bg-purple-100 transition-all">
                        <Upload className="h-12 w-12 text-purple-400 mb-3" />
                        <span className="text-sm font-medium text-gray-700">Cliquez pour ajouter des photos</span>
                        <span className="text-xs text-gray-500 mt-1">PNG, JPG jusqu'à 10MB (plusieurs photos possibles)</span>
                        <input
                          type="file"
                          className="hidden"
                          accept="image/*"
                          multiple
                          onChange={handlePhotosUpload}
                        />
                      </label>

                      {/* Aperçu des photos */}
                      {photosPreviews.length > 0 && (
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                          {photosPreviews.map((preview, index) => (
                            <div key={index} className="relative group">
                              <img
                                src={preview}
                                alt={`Photo ${index + 1}`}
                                className="w-full h-32 object-cover rounded-lg border-2 border-purple-300 shadow-md"
                              />
                              <button
                                type="button"
                                onClick={() => removePhoto(index)}
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
                              >
                                <X className="h-4 w-4" />
                              </button>
                              <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
                                Photo {index + 1}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Image principale (ancienne méthode conservée pour compatibilité) */}
                      {imagePreview && (
                        <div className="border-t pt-4">
                          <label className="block text-sm font-medium text-gray-700 mb-2">Image principale</label>
                          <div className="space-y-3">
                            <img src={imagePreview} alt="Preview" className="mx-auto h-40 w-40 object-cover rounded-lg border-2 border-blue-300" />
                            <button
                              type="button"
                              onClick={() => {
                                setImageFile(null);
                                setImagePreview(null);
                              }}
                              className="text-sm text-red-600 hover:text-red-700"
                            >
                              Supprimer l'image principale
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>


                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">URL de l'image (optionnel)</label>
                    <input
                      type="text"
                      value={newBijou.image_url}
                      onChange={(e) => setNewBijou({...newBijou, image_url: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="https://..."
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3 border-t">
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setImageFile(null);
                  setImagePreview(null);
                }}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={handleCreateBijou}
                disabled={saving || !newBijou.reference || !newBijou.nom}
                className="flex items-center space-x-2 px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {saving ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    <span>Enregistrement...</span>
                  </>
                ) : (
                  <>
                    <Save className="h-5 w-5" />
                    <span>Enregistrer</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'édition de bijou */}
      {showEditModal && editingBijou && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl max-w-4xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r from-green-600 to-teal-600 text-white px-6 py-4 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <Edit className="h-6 w-6" />
                <h3 className="text-xl font-bold">Modifier le bijou</h3>
              </div>
              <button
                onClick={() => {
                  setShowEditModal(false);
                  setEditingBijou(null);
                  setImageFile(null);
                  setImagePreview(null);
                }}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Colonne gauche */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Référence modèle
                      <span className="ml-1 text-xs text-gray-400 font-normal">(ex : BAGB21)</span>
                    </label>
                    <input
                      type="text"
                      value={editingBijou.reference_article || ''}
                      onChange={(e) => setEditingBijou({...editingBijou, reference_article: e.target.value.toUpperCase()})}
                      placeholder="BAGB21"
                      className="w-full px-3 py-2 border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 font-mono font-bold uppercase text-purple-700 bg-purple-50"
                    />
                    <p className="text-xs text-gray-400 mt-1">Référence du modèle — identique pour toutes les pièces du même modèle</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Référence pièce unique</label>
                    <input
                      type="text"
                      value={editingBijou.reference}
                      onChange={(e) => setEditingBijou({...editingBijou, reference: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 font-mono text-sm"
                      required
                    />
                    <p className="text-xs text-gray-400 mt-1">Générée automatiquement : BAGB21 1.1362</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nom / Désignation *</label>
                    <input
                      type="text"
                      value={editingBijou.nom}
                      onChange={(e) => setEditingBijou({...editingBijou, nom: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Catégorie</label>
                      <select
                        value={editingBijou.categorie}
                        onChange={(e) => setEditingBijou({...editingBijou, categorie: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      >
                        <option value="bague">Bague</option>
                        <option value="collier">Collier</option>
                        <option value="bracelet">Bracelet</option>
                        <option value="boucles_oreilles">Boucles d'oreilles</option>
                        <option value="pendentif">Pendentif</option>
                        <option value="montre">Montre</option>
                        <option value="autre">Autre</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Matière</label>
                      <select
                        value={editingBijou.matiere}
                        onChange={(e) => setEditingBijou({...editingBijou, matiere: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      >
                        <option value="or">Or</option>
                        <option value="argent">Argent</option>
                        <option value="platine">Platine</option>
                        <option value="diamant">Diamant</option>
                        <option value="perle">Perle</option>
                        <option value="autre">Autre</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Poids (g)</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={editingBijou.poids}
                        onChange={(e) => setEditingBijou({...editingBijou, poids: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Dimensions</label>
                      <input
                        type="text"
                        value={editingBijou.dimensions}
                        onChange={(e) => setEditingBijou({...editingBijou, dimensions: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Pierres</label>
                    <textarea
                      value={editingBijou.pierres}
                      onChange={(e) => setEditingBijou({...editingBijou, pierres: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      rows="2"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Certificat</label>
                    <input
                      type="text"
                      value={editingBijou.certificat}
                      onChange={(e) => setEditingBijou({...editingBijou, certificat: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>
                </div>

                {/* Colonne droite */}
                <div className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prix d'achat (DH) *</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={editingBijou.prix_achat}
                        onChange={(e) => setEditingBijou({...editingBijou, prix_achat: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prix de vente (DH) *</label>
                      <input
                        type="text" inputMode="decimal" onFocus={e => e.target.select()}
                        step="0.01"
                        value={editingBijou.prix_vente}
                        onChange={(e) => setEditingBijou({...editingBijou, prix_vente: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Stock minimum</label>
                    <input
                      type="text" inputMode="decimal" onFocus={e => e.target.select()}
                      value={editingBijou.stock_minimum}
                      onChange={(e) => setEditingBijou({...editingBijou, stock_minimum: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                    <textarea
                      value={editingBijou.description}
                      onChange={(e) => setEditingBijou({...editingBijou, description: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      rows="3"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Collection <span className="text-gray-400 text-xs">(classe les images dans le bon dossier)</span>
                    </label>
                    <input
                      type="text"
                      value={editingBijou.collection_nom || ''}
                      onChange={(e) => setEditingBijou({...editingBijou, collection_nom: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                      placeholder="Ex: Nasha, Client, Autre... (vide = classé par type)"
                    />
                    <p className="text-xs text-gray-400 mt-1">
                      {editingBijou.collection_nom
                        ? `📁 collections/${editingBijou.categorie}/${editingBijou.collection_nom}/`
                        : `📁 clients/${editingBijou.categorie}/`}
                    </p>
                  </div>

                  {/* Galerie d'images */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Images du bijou (plusieurs possibles)</label>
                    
                    {/* Zone d'upload */}
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-green-500 transition-colors mb-4">
                      <Upload className="mx-auto h-12 w-12 text-gray-400 mb-2" />
                      <label className="cursor-pointer">
                        <span className="text-green-600 hover:text-green-700 font-medium">Ajouter des images</span>
                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={handlePhotosUpload}
                          className="hidden"
                        />
                      </label>
                      <p className="text-xs text-gray-500 mt-1">PNG, JPG, GIF - Plusieurs images possibles</p>
                    </div>

                    {/* Galerie de previews */}
                    {(photosPreviews.length > 0 || imagePreview) && (
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                        {imagePreview && (
                          <div className="relative group">
                            <img src={imagePreview} alt="Preview" className="w-full h-24 object-cover rounded-lg border-2 border-green-500" />
                            <div className="absolute top-1 right-1 bg-green-500 text-white text-xs px-2 py-1 rounded">Principale</div>
                            <button
                              type="button"
                              onClick={() => {
                                setImageFile(null);
                                setImagePreview(null);
                              }}
                              className="absolute top-1 left-1 bg-red-500 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <X className="h-4 w-4" />
                            </button>
                          </div>
                        )}
                        {photosPreviews.map((preview, index) => (
                          <div key={index} className="relative group">
                            <img src={preview} alt={`Preview ${index + 1}`} className="w-full h-24 object-cover rounded-lg border-2 border-gray-300" />
                            <button
                              type="button"
                              onClick={() => removePhoto(index)}
                              className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <X className="h-4 w-4" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* ── Section Médias & Documents ── */}
                  <div className="border-t pt-4">
                    <h4 className="text-sm font-bold text-gray-700 mb-3">📎 Médias & Documents</h4>

                    {/* Upload */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                      {[
                        { type: 'photo', label: '📸 Photo', accept: 'image/*' },
                        { type: 'certificat', label: '📜 Certificat', accept: 'image/*,.pdf' },
                        { type: 'document', label: '📄 Document', accept: 'image/*,.pdf' },
                      ].map(({ type, label, accept }) => (
                        <label key={type} className="cursor-pointer">
                          <div className={`text-center py-2 px-2 rounded-lg border-2 border-dashed text-xs font-medium transition-colors ${uploadingFichier ? 'opacity-50' : 'hover:bg-gray-50 border-gray-300'}`}>
                            {label}
                            {uploadingFichier ? <span className="block text-gray-400">Upload...</span> : <span className="block text-gray-400">Cliquer</span>}
                          </div>
                          <input type="file" accept={accept} className="hidden" disabled={uploadingFichier}
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (!file) return;
                              setUploadingFichier(true);
                              const fd = new FormData();
                              fd.append('fichier', file);
                              fd.append('type_fichier', type);
                              fd.append('nom_fichier', file.name);
                              fd.append('est_principale', bijouFichiers.filter(f => f.type_fichier === 'photo').length === 0 && type === 'photo' ? '1' : '0');
                              try {
                                const r = await fetch(`${API_URL}/bijoux-images/bijou/${editingBijou.id}/upload`, {
                                  method: 'POST', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }, body: fd
                                });
                                if (r.ok) {
                                  const data = await r.json();
                                  setBijouFichiers(prev => [...prev, { id: data.id, image_url: data.url, type_fichier: type, nom_fichier: file.name, est_principale: 0 }]);
                                  if (type === 'photo' && !editingBijou.image_url) setEditingBijou(b => ({ ...b, image_url: data.url }));
                                }
                              } catch {}
                              setUploadingFichier(false);
                              e.target.value = '';
                            }}
                          />
                        </label>
                      ))}
                    </div>

                    {/* Liste des fichiers */}
                    {bijouFichiers.length === 0 ? (
                      <p className="text-xs text-gray-400 text-center py-2">Aucun fichier — ajoutez des photos, certificats ou documents</p>
                    ) : (
                      <div className="space-y-1 max-h-48 overflow-y-auto">
                        {bijouFichiers.map(f => {
                          const isImage = f.image_url && !f.image_url.endsWith('.pdf');
                          const baseUrl = API_URL.replace('/api', '');
                          const fullUrl = f.image_url?.startsWith('/') ? `${baseUrl}${f.image_url}` : f.image_url;
                          const typeBadge = { photo: 'bg-blue-100 text-blue-700', certificat: 'bg-yellow-100 text-yellow-700', document: 'bg-gray-100 text-gray-600' };
                          return (
                            <div key={f.id} className="flex items-center gap-2 p-1.5 rounded-lg bg-gray-50 border border-gray-200">
                              {isImage ? (
                                <img src={fullUrl} alt="" className="w-10 h-10 object-cover rounded border border-gray-200 flex-shrink-0" />
                              ) : (
                                <div className="w-10 h-10 rounded bg-red-100 flex items-center justify-center text-red-600 text-xs font-bold flex-shrink-0">PDF</div>
                              )}
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-1.5">
                                  <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${typeBadge[f.type_fichier] || typeBadge.document}`}>{f.type_fichier}</span>
                                  {f.est_principale === 1 && <span className="text-xs bg-green-100 text-green-700 px-1.5 py-0.5 rounded">⭐ Principale</span>}
                                </div>
                                <p className="text-xs text-gray-500 truncate mt-0.5">{f.nom_fichier || f.image_url}</p>
                              </div>
                              <div className="flex gap-1 flex-shrink-0">
                                {f.type_fichier === 'photo' && f.est_principale !== 1 && (
                                  <button type="button" title="Définir comme principale"
                                    onClick={async () => {
                                      await fetch(`${API_URL}/bijoux-images/bijou/fichier/${f.id}/principale`, { method: 'PUT', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
                                      setBijouFichiers(prev => prev.map(x => ({ ...x, est_principale: x.id === f.id ? 1 : (x.type_fichier === 'photo' ? 0 : x.est_principale) })));
                                      setEditingBijou(b => ({ ...b, image_url: f.image_url }));
                                    }}
                                    className="p-1 rounded text-yellow-500 hover:bg-yellow-50">⭐</button>
                                )}
                                <a href={fullUrl} target="_blank" rel="noreferrer" className="p-1 rounded text-blue-500 hover:bg-blue-50 text-xs">👁</a>
                                <button type="button" title="Supprimer"
                                  onClick={async () => {
                                    if (!window.confirm('Supprimer ce fichier ?')) return;
                                    await fetch(`${API_URL}/bijoux-images/bijou/fichier/${f.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
                                    setBijouFichiers(prev => prev.filter(x => x.id !== f.id));
                                  }}
                                  className="p-1 rounded text-red-400 hover:bg-red-50">🗑</button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3 border-t">
              <button
                onClick={() => {
                  setShowEditModal(false);
                  setEditingBijou(null);
                  setImageFile(null);
                  setImagePreview(null);
                }}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={handleUpdateBijou}
                disabled={saving || !editingBijou.reference || !editingBijou.nom}
                className="flex items-center space-x-2 px-6 py-2 bg-gradient-to-r from-green-600 to-teal-600 text-white rounded-lg hover:from-green-700 hover:to-teal-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {saving ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    <span>Enregistrement...</span>
                  </>
                ) : (
                  <>
                    <Save className="h-5 w-5" />
                    <span>Mettre à jour</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de création avec le nouveau composant */}
      {showCreateModal && (
        <CreerBijou
          onClose={() => setShowCreateModal(false)}
          onSuccess={loadBijoux}
        />
      )}

      {/* Panier de production flottant */}
      {/* ── Panier de production ── */}
      {/* ── Modal résultat de lancement ─────────────────────────────────── */}
      {resultatLancement && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <div>
                <h3 className="font-bold text-gray-900 text-lg">Production lancée</h3>
                <p className="text-sm text-gray-500">
                  OF : <span className="font-mono font-bold text-blue-600">{resultatLancement.numero_of}</span>
                  {resultatLancement.client_nom && <span className="ml-2 text-purple-600 font-medium">· {resultatLancement.client_nom}</span>}
                  {' — '}{resultatLancement.nb_pieces} pièce(s) créée(s)
                </p>
              </div>
              <button onClick={() => setResultatLancement(null)} className="p-2 hover:bg-gray-100 rounded-full">
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>
            {/* Liste des pièces */}
            <div className="overflow-y-auto flex-1 px-6 py-4 space-y-2">
              {resultatLancement.pieces.map((piece, idx) => (
                <div key={idx} className="flex items-center gap-3 bg-gray-50 rounded-xl px-4 py-3 border border-gray-100">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      {/* Référence modèle */}
                      <span className="font-mono font-bold text-sm text-purple-700 bg-purple-50 px-2 py-0.5 rounded">
                        {piece.reference_article}
                      </span>
                      {/* ID pièce unique */}
                      <span className="font-mono text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                        {piece.id_produit}
                      </span>
                      <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
                        piece.couleur_or === 'BLANC' ? 'bg-gray-100 text-gray-600' :
                        piece.couleur_or === 'ROSE'  ? 'bg-pink-100 text-pink-600' :
                                                        'bg-yellow-100 text-yellow-700'
                      }`}>Or {piece.couleur_or?.toLowerCase()}</span>
                    </div>
                    {piece.nom && piece.nom.toUpperCase() !== (piece.reference_article || '').toUpperCase() && (
                      <p className="text-xs text-gray-500 mt-0.5 truncate">{piece.nom}</p>
                    )}
                    {piece.nb_etapes > 0 && (
                      <p className="text-xs text-green-600 mt-0.5">{piece.nb_etapes} étape(s) de fabrication copiées</p>
                    )}
                  </div>
                  <button
                    onClick={() => {
                      setPieceEnEdition(piece);
                      setChampsPiece({
                        notes_variation: piece.notes_variation || '',
                        observation_piece: piece.observation_piece || '',
                        couleur_or: piece.couleur_or || 'JAUNE',
                        taille_diamant: piece.taille_diamant || '',
                        rhodiage: piece.rhodiage || false,
                        gravure_beldi: piece.gravure_beldi || false,
                        ecrin: piece.ecrin || false,
                        garantie: piece.garantie || false,
                      });
                    }}
                    className="flex-shrink-0 flex items-center gap-1 px-3 py-1.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-xs font-semibold transition-colors"
                  >
                    <Edit className="h-3 w-3" />
                    Personnaliser
                  </button>
                </div>
              ))}
            </div>
            <div className="px-6 py-3 border-t border-gray-100 text-right">
              <button onClick={() => setResultatLancement(null)}
                className="px-5 py-2 bg-gray-800 hover:bg-gray-900 text-white rounded-lg text-sm font-semibold">
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal FICHE FABRICATION complète ────────────────────────────── */}
      {ficheFabBijouId && (
        <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center bg-black/60 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-4xl max-h-[95vh] sm:max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
              <div>
                <h3 className="font-bold text-lg text-gray-900">Fiche de fabrication</h3>
                {ficheFabData && (
                  <p className="text-sm text-gray-500 font-mono">
                    {ficheFabData._reference_article} · {ficheFabData._id_produit}
                  </p>
                )}
              </div>
              <button onClick={() => { setFicheFabBijouId(null); setFicheFabData(null); setFicheFabFichiers([]); }}
                className="p-2 hover:bg-gray-100 rounded-full">
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>

            {ficheFabLoading ? (
              <div className="flex-1 flex items-center justify-center py-20">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
              </div>
            ) : ficheFabData && (
              <div className="flex-1 overflow-y-auto px-6 py-5 space-y-6">

                {/* ═══ SECTION 1 : Infos générales ═══ */}
                <div>
                  <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Informations générales</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Désignation</label>
                      <input type="text" value={ficheFabData.nom}
                        onChange={e => setFicheFabData(d => ({ ...d, nom: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Collection</label>
                      <select value={ficheFabData.collection_nom}
                        onChange={e => setFicheFabData(d => ({ ...d, collection_nom: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400">
                        <option value="">— Aucune —</option>
                        {(ficheFabData._collections_liste || []).map(c => (
                          <option key={c.id} value={c.nom}>{c.nom}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-xs font-semibold text-gray-600 mb-1">Description</label>
                      <textarea rows={2} value={ficheFabData.description}
                        onChange={e => setFicheFabData(d => ({ ...d, description: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 resize-none" />
                    </div>
                  </div>
                </div>

                {/* ═══ SECTIONS 2-7 : Style devis (recherche autocomplete) ═══ */}
                <div>
                  <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Composants de fabrication</h4>
                  {/* Composants déjà ajoutés */}
                  {ficheFabData.composants.length > 0 && (
                    <div className="space-y-2 mb-3">
                      {ficheFabData.composants.map((comp, idx) => (
                        <div key={idx} className="flex items-center gap-2 bg-purple-50 rounded-lg px-3 py-2 border border-purple-200">
                          <span className="flex-1 text-sm font-medium">{comp.nom}</span>
                          <div className="flex items-center gap-1">
                            <label className="text-xs text-gray-500">Qté:</label>
                            <input type="text" inputMode="decimal" onFocus={e => e.target.select()} step="0.01" min="0" value={comp.quantite}
                              onChange={e => {
                                const q = e.target.value;
                                setFicheFabData(d => ({
                                  ...d,
                                  composants: d.composants.map((c, i) => i === idx
                                    ? { ...c, quantite: q, cout_total: (parseFloat(q) * parseFloat(c.prix_unitaire || 0)).toFixed(2) }
                                    : c)
                                }));
                              }}
                              className="w-16 px-2 py-1 border border-gray-300 rounded text-xs text-center" />
                          </div>
                          <span className="text-xs text-gray-500 bg-white px-2 py-0.5 rounded border min-w-[70px] text-right">
                            {parseFloat(comp.cout_total || 0).toFixed(2)} DH
                          </span>
                          <button onClick={() => setFicheFabData(d => ({ ...d, composants: d.composants.filter((_, i) => i !== idx) }))}
                            className="p-1 hover:bg-red-100 rounded text-red-400 hover:text-red-600">
                            <X className="h-3.5 w-3.5" />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* Ajouter un composant */}
                  <div className="flex flex-wrap gap-2">
                    {optionsDisponibles.filter(cf =>
                      !ficheFabData.composants.some(c => c.cout_fabrication_id === cf.id)
                    ).map(cf => (
                      <button key={cf.id}
                        onClick={() => setFicheFabData(d => ({
                          ...d,
                          composants: [...d.composants, {
                            cout_fabrication_id: cf.id,
                            nom: cf.nom,
                            quantite: 1,
                            prix_unitaire: cf.cout,
                            cout_total: parseFloat(cf.cout || 0).toFixed(2),
                            notes: '',
                          }]
                        }))}
                        className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-dashed border-gray-300 hover:border-purple-400 hover:bg-purple-50 rounded-lg text-xs font-medium text-gray-600 hover:text-purple-700 transition-all"
                      >
                        <Plus className="h-3 w-3" />
                        {cf.nom}
                        <span className="text-gray-400 ml-1">
                          {cf.type_cout === 'MINUTE' ? `${cf.cout} DH/min` : `${cf.cout} DH`}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* ═══ SECTION 3 : Packaging ═══ */}
                {ficheFabData._packaging_list.length > 0 && (
                  <div>
                    <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Packaging</h4>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                      {ficheFabData._packaging_list.map(pkg => (
                        <button key={pkg.id}
                          onClick={() => setFicheFabData(d => ({ ...d, packaging_id: d.packaging_id === pkg.id ? null : pkg.id }))}
                          className={`text-center px-2 py-3 rounded-xl border-2 transition-all text-xs ${
                            ficheFabData.packaging_id === pkg.id
                              ? 'border-purple-500 bg-purple-50 shadow-sm'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}>
                          <div className="font-bold">{pkg.type}</div>
                          <div className="text-gray-500 mt-0.5">{parseFloat(pkg.prix_ttc).toFixed(0)} DH</div>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* ═══ SECTION 4 : Matières / Or (recherche comme devis) ═══ */}
                <div>
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-xs font-bold text-amber-600 uppercase tracking-wider">Matières / Or</h4>
                    <button onClick={() => setFicheFabData(d => ({ ...d, matieres_utilisees: [...(d.matieres_utilisees || []), { stock_matiere_id: null, designation: '', type_matiere: '', quantite: '', prix_achat_unitaire: 0, _search: '' }] }))}
                      className="flex items-center gap-1 px-3 py-1.5 bg-amber-500 text-white rounded-lg text-xs font-semibold hover:bg-amber-600">
                      <Plus className="h-3 w-3" /> Ajouter
                    </button>
                  </div>
                  {(ficheFabData.matieres_utilisees || []).map((mat, idx) => (
                    <div key={idx} className="bg-yellow-50 rounded-xl p-4 mb-3 border border-yellow-200">
                      <div className="flex justify-between items-start mb-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xl">🥇</span>
                          <div>
                            <div className="font-bold text-sm text-yellow-900">{mat.designation || 'Nouvelle matière'}</div>
                            <div className="text-xs text-yellow-600">{mat.type_matiere || ''}</div>
                          </div>
                        </div>
                        <button onClick={() => setFicheFabData(d => ({ ...d, matieres_utilisees: d.matieres_utilisees.filter((_, i) => i !== idx) }))}
                          className="p-1 hover:bg-red-100 rounded text-red-400"><X className="h-4 w-4" /></button>
                      </div>
                      {!mat.stock_matiere_id && (
                        <div className="relative mb-2">
                          <input type="text" placeholder="Tapez pour chercher (or, chaîne, mousqueton...)"
                            value={mat._search || ''}
                            onChange={e => {
                              const v = e.target.value;
                              setFicheFabData(d => ({ ...d, matieres_utilisees: d.matieres_utilisees.map((x, i) => i === idx ? { ...x, _search: v } : x) }));
                            }}
                            className="w-full px-3 py-2 border border-yellow-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-400" />
                          {mat._search && mat._search.length >= 1 && (
                            <div className="absolute z-50 w-full mt-1 bg-white border border-yellow-300 rounded-xl shadow-xl max-h-48 overflow-y-auto">
                              {(ficheFabData._matieres_stock || []).filter(ms =>
                                (ms.designation || '').toLowerCase().includes((mat._search || '').toLowerCase()) ||
                                (ms.type_matiere || '').toLowerCase().includes((mat._search || '').toLowerCase())
                              ).map(ms => (
                                <div key={ms.id}
                                  onClick={() => setFicheFabData(d => ({ ...d, matieres_utilisees: d.matieres_utilisees.map((x, i) => i === idx ? { stock_matiere_id: ms.id, designation: ms.designation, type_matiere: ms.type_matiere, quantite: '', prix_achat_unitaire: ms.prix_achat_unitaire, _search: '' } : x) }))}
                                  className="px-4 py-3 hover:bg-yellow-50 cursor-pointer border-b last:border-0">
                                  <div className="font-semibold text-sm">{ms.designation}</div>
                                  <div className="flex gap-3 text-xs text-gray-500">
                                    <span>{ms.type_matiere}</span>
                                    <span className="text-green-600 font-semibold">{ms.prix_achat_unitaire} DH/g</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                      {mat.stock_matiere_id && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Quantité (g)</label>
                            <input type="text" value={mat.quantite} placeholder="0.00"
                              onChange={e => setFicheFabData(d => ({ ...d, matieres_utilisees: d.matieres_utilisees.map((x, i) => i === idx ? { ...x, quantite: e.target.value.replace(',', '.') } : x) }))}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Prix unitaire</label>
                            <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-600">{mat.prix_achat_unitaire} DH/g</div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>


                {/* ═══ SECTION 5 : Pierres (recherche comme devis) ═══ */}
                <div>
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-xs font-bold text-indigo-600 uppercase tracking-wider">Pierres</h4>
                    <button onClick={() => setFicheFabData(d => ({ ...d, pierres_of: [...d.pierres_of, { type_pierre: '', designation: '', quantite: 1, poids_carats: '', sertisseur: '', observation: '', prix_achat_carat: '', stock_matiere_id: null, _search: '' }] }))}
                      className="flex items-center gap-1 px-3 py-1.5 bg-indigo-500 text-white rounded-lg text-xs font-semibold hover:bg-indigo-600">
                      <Plus className="h-3 w-3" /> Ajouter
                    </button>
                  </div>
                  {ficheFabData.pierres_of.map((p, idx) => (
                    <div key={idx} className="bg-indigo-50 rounded-xl p-4 mb-3 border border-indigo-200">
                      <div className="flex justify-between items-start mb-2">
                        <div className="flex items-center gap-2">
                          <span className="text-xl">💎</span>
                          <div>
                            <div className="font-bold text-sm text-indigo-900">{p.designation || p.type_pierre || 'Nouvelle pierre'}</div>
                            {p.type_pierre && p.designation && <div className="text-xs text-indigo-500">{p.type_pierre}</div>}
                          </div>
                        </div>
                        <button onClick={() => setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.filter((_, i) => i !== idx) }))}
                          className="p-1 hover:bg-red-100 rounded text-red-400"><X className="h-4 w-4" /></button>
                      </div>
                      {!p.stock_matiere_id && !p.designation && (
                        <div className="relative mb-2">
                          <input type="text" placeholder="Tapez pour chercher (diamant, saphir, rubis...)"
                            value={p._search || ''}
                            onChange={e => {
                              const v = e.target.value;
                              setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.map((x, i) => i === idx ? { ...x, _search: v } : x) }));
                            }}
                            className="w-full px-3 py-2 border border-indigo-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-400" />
                          {p._search && p._search.length >= 1 && (
                            <div className="absolute z-50 w-full mt-1 bg-white border border-indigo-300 rounded-xl shadow-xl max-h-48 overflow-y-auto">
                              {(ficheFabData._pierres_stock || []).filter(ps =>
                                (ps.designation || '').toLowerCase().includes((p._search || '').toLowerCase()) ||
                                (ps.type_matiere || '').toLowerCase().includes((p._search || '').toLowerCase())
                              ).map(ps => (
                                <div key={ps.id}
                                  onClick={() => setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.map((x, i) => i === idx ? { ...x, type_pierre: ps.type_matiere, designation: ps.designation, stock_matiere_id: ps.id, prix_achat_carat: ps.prix_achat_carat || ps.prix_achat_unitaire || '', _search: '' } : x) }))}
                                  className="px-4 py-3 hover:bg-indigo-50 cursor-pointer border-b last:border-0">
                                  <div className="font-semibold text-sm text-indigo-700">{ps.designation}</div>
                                  <div className="flex gap-3 text-xs text-gray-500">
                                    <span>{ps.type_matiere}</span>
                                    {ps.taille_qualite && <span>{ps.taille_qualite}</span>}
                                    {ps.prix_achat_carat > 0 && <span className="text-green-600 font-semibold">{ps.prix_achat_carat} DH/ct</span>}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                      {(p.stock_matiere_id || p.designation) && (
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Quantité</label>
                            <input type="text" value={p.quantite} placeholder="1"
                              onChange={e => setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.map((x, i) => i === idx ? { ...x, quantite: e.target.value.replace(',', '.') } : x) }))}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Poids (carats)</label>
                            <input type="text" value={p.poids_carats} placeholder="0.00"
                              onChange={e => setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.map((x, i) => i === idx ? { ...x, poids_carats: e.target.value.replace(',', '.') } : x) }))}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs text-gray-500 mb-1">Sertisseur</label>
                            <input type="text" value={p.sertisseur || ''} placeholder="Optionnel"
                              onChange={e => setFicheFabData(d => ({ ...d, pierres_of: d.pierres_of.map((x, i) => i === idx ? { ...x, sertisseur: e.target.value } : x) }))}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* ═══ SECTION 6 : Prix théorique vs réel (masqué à la vendeuse) ═══ */}
                {/* §205 : garde sur le RÔLE (isVendeuse), pas le workspace (isBoutique) */}
                {!isVendeuse && (
                <div>
                  <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Prix et coûts</h4>

                  {/* Théorique (estimé au devis) */}
                  <div className="mb-4">
                    <label className="block text-xs font-semibold text-blue-600 mb-2">Estimé (théorique / devis)</label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                      {[
                        { key: 'cout_metal', label: 'Coût métal' },
                        { key: 'cout_pierres', label: 'Coût pierres' },
                        { key: 'cout_main_oeuvre', label: "Main d'oeuvre" },
                        { key: 'prix_theorique', label: 'Prix théorique total' },
                        { key: 'prix_vente', label: 'Prix vente' },
                        { key: 'coefficient_marge', label: 'Coeff. marge' },
                      ].map(({ key, label }) => (
                        <div key={key}>
                          <label className="block text-xs text-gray-600 mb-1">{label}</label>
                          <input type="text" value={ficheFabData[key]}
                            onChange={e => {
                              const v = e.target.value.replace(',', '.');
                              setFicheFabData(d => ({ ...d, [key]: v }));
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-400"
                            placeholder="0.00" />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Réel (après production) */}
                  <div>
                    <label className="block text-xs font-semibold text-green-600 mb-2">Réel (après production)</label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                      {[
                        { key: 'cout_reel_metal', label: 'Coût métal réel' },
                        { key: 'cout_reel_main_oeuvre', label: "Main d'oeuvre réelle" },
                        { key: 'cout_reel_total', label: 'Coût réel total' },
                      ].map(({ key, label }) => (
                        <div key={key}>
                          <label className="block text-xs text-gray-600 mb-1">{label}</label>
                          <input type="text" value={ficheFabData[key]}
                            onChange={e => {
                              const v = e.target.value.replace(',', '.');
                              setFicheFabData(d => ({ ...d, [key]: v }));
                            }}
                            className="w-full px-3 py-2 border border-green-200 bg-green-50 rounded-lg text-sm focus:ring-2 focus:ring-green-400"
                            placeholder="Calculé après production" />
                        </div>
                      ))}
                    </div>
                    {/* Écart */}
                    {ficheFabData.prix_theorique && ficheFabData.cout_reel_total && (
                      <div className={`mt-3 rounded-lg px-3 py-2 text-xs font-semibold ${
                        parseFloat(ficheFabData.cout_reel_total) > parseFloat(ficheFabData.prix_theorique)
                          ? 'bg-red-50 border border-red-200 text-red-700'
                          : 'bg-green-50 border border-green-200 text-green-700'
                      }`}>
                        Écart : {(parseFloat(ficheFabData.cout_reel_total || 0) - parseFloat(ficheFabData.prix_theorique || 0)).toFixed(2)} DH
                        {parseFloat(ficheFabData.cout_reel_total) > parseFloat(ficheFabData.prix_theorique) ? ' (plus cher que prévu)' : ' (moins cher que prévu)'}
                      </div>
                    )}
                  </div>
                </div>

                )}

                {/* ═══ SECTION 7 : Notes ═══ */}
                <div>
                  <h4 className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Notes</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Consignes atelier</label>
                      <textarea rows={2} value={ficheFabData.consigne}
                        onChange={e => setFicheFabData(d => ({ ...d, consigne: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 resize-none" />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Observations</label>
                      <textarea rows={2} value={ficheFabData.observation_piece}
                        onChange={e => setFicheFabData(d => ({ ...d, observation_piece: e.target.value }))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 resize-none" />
                    </div>
                  </div>
                </div>

                {/* ═══ SECTION 8b : Photos, certificats, documents ═══ */}
                <div className="border-t-2 border-amber-200 pt-5">
                  <h4 className="text-xs font-bold text-amber-600 uppercase tracking-wider mb-3">📎 Photos & Documents</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                    {[
                      { label: '📸 Photo', type: 'photo' },
                      { label: '🏅 Certificat', type: 'certificat' },
                      { label: '📄 Document', type: 'document' },
                    ].map(({ label, type }) => (
                      <label key={type} className="flex flex-col items-center gap-1 p-2 border-2 border-dashed border-amber-300 rounded-lg hover:bg-amber-50 cursor-pointer text-xs text-amber-700 font-medium transition-colors">
                        {uploadingFicheFab ? <span className="animate-spin h-4 w-4 border-2 border-amber-500 border-t-transparent rounded-full" /> : label}
                        <input type="file" className="hidden"
                          accept={type === 'document' ? '.pdf,.jpg,.jpeg,.png,.gif,.webp' : '.jpg,.jpeg,.png,.gif,.webp'}
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (!file || !ficheFabBijouId) return;
                            setUploadingFicheFab(true);
                            const fd = new FormData();
                            fd.append('fichier', file);
                            fd.append('type_fichier', type);
                            fd.append('nom_fichier', file.name);
                            fd.append('est_principale', ficheFabFichiers.filter(f => f.type_fichier === 'photo').length === 0 && type === 'photo' ? '1' : '0');
                            try {
                              const r = await fetch(`${API_URL}/bijoux-images/bijou/${ficheFabBijouId}/upload`, {
                                method: 'POST', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }, body: fd
                              });
                              if (r.ok) {
                                const data = await r.json();
                                setFicheFabFichiers(prev => [...prev, { id: data.id, image_url: data.url, type_fichier: type, nom_fichier: file.name, est_principale: 0 }]);
                              }
                            } catch {}
                            finally { setUploadingFicheFab(false); }
                          }} />
                      </label>
                    ))}
                  </div>
                  {ficheFabFichiers.length === 0 ? (
                    <p className="text-xs text-gray-400 text-center py-2">Aucun fichier — ajoutez des photos, certificats ou documents</p>
                  ) : (
                    <div className="space-y-1 max-h-48 overflow-y-auto">
                      {ficheFabFichiers.map(f => {
                        const isImage = f.image_url && !f.image_url.endsWith('.pdf');
                        const baseUrl = API_URL.replace('/api', '');
                        const fullUrl = f.image_url?.startsWith('/') ? `${baseUrl}${f.image_url}` : f.image_url;
                        const typeBadge = { photo: 'bg-blue-100 text-blue-700', certificat: 'bg-yellow-100 text-yellow-700', document: 'bg-gray-100 text-gray-700' };
                        return (
                          <div key={f.id} className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2 border border-gray-200">
                            {isImage ? (
                              <img src={fullUrl} alt="" className="h-10 w-10 object-cover rounded border" onError={e => { e.target.style.display='none'; }} />
                            ) : (
                              <div className="h-10 w-10 flex items-center justify-center bg-gray-200 rounded border text-xs font-bold text-gray-500">PDF</div>
                            )}
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-1.5">
                                <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${typeBadge[f.type_fichier] || typeBadge.document}`}>{f.type_fichier}</span>
                                {f.est_principale === 1 && <span className="text-xs bg-green-100 text-green-700 px-1.5 py-0.5 rounded">⭐ Principale</span>}
                              </div>
                              <p className="text-xs text-gray-500 truncate mt-0.5">{f.nom_fichier || f.image_url?.split('/').pop()}</p>
                            </div>
                            <div className="flex gap-1">
                              {f.type_fichier === 'photo' && f.est_principale !== 1 && (
                                <button onClick={async () => {
                                  await fetch(`${API_URL}/bijoux-images/bijou/fichier/${f.id}/principale`, { method: 'PUT', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
                                  setFicheFabFichiers(prev => prev.map(x => ({ ...x, est_principale: x.id === f.id ? 1 : 0 })));
                                }} className="text-xs px-2 py-1 bg-green-100 hover:bg-green-200 text-green-700 rounded font-medium">⭐</button>
                              )}
                              <button onClick={async () => {
                                await fetch(`${API_URL}/bijoux-images/bijou/fichier/${f.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
                                setFicheFabFichiers(prev => prev.filter(x => x.id !== f.id));
                              }} className="text-xs px-2 py-1 bg-red-100 hover:bg-red-200 text-red-600 rounded font-medium">🗑</button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* ═══ SECTION 8 : Historique fabrication (lecture seule) ═══ */}
                {(ficheFabData._of_data || ficheFabData._etapes_production.length > 0 || ficheFabData._ouvriers_production.length > 0) && (
                  <div className="border-t-2 border-blue-200 pt-5">
                    <h4 className="text-xs font-bold text-blue-600 uppercase tracking-wider mb-3">Historique de fabrication</h4>

                    {ficheFabData._of_data && (
                      <div className="bg-blue-50 rounded-xl p-3 mb-3 border border-blue-200">
                        <div className="flex items-center gap-4 flex-wrap text-sm">
                          <div>
                            <span className="text-xs text-gray-500">OF</span>
                            <p className="font-mono font-bold text-blue-800">{ficheFabData._of_data.numero_ordre}</p>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Date création</span>
                            <p className="font-medium">{ficheFabData._date_fabrication ? new Date(ficheFabData._date_fabrication).toLocaleDateString('fr-FR') : '—'}</p>
                          </div>
                          <div>
                            <span className="text-xs text-gray-500">Statut</span>
                            <p className={`font-semibold capitalize ${
                              ficheFabData._statut_fabrication === 'termine' ? 'text-green-600' :
                              ficheFabData._statut_fabrication === 'en_fabrication' ? 'text-amber-600' : 'text-gray-600'
                            }`}>{ficheFabData._statut_fabrication || '—'}</p>
                          </div>
                          {ficheFabData._of_data.date_livraison_prevue && (
                            <div>
                              <span className="text-xs text-gray-500">Livraison prévue</span>
                              <p className="font-medium">{new Date(ficheFabData._of_data.date_livraison_prevue).toLocaleDateString('fr-FR')}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {ficheFabData._ouvriers_production.length > 0 && (
                      <div className="mb-3">
                        <label className="block text-xs text-gray-500 mb-1.5 font-semibold">Ouvriers</label>
                        <div className="flex flex-wrap gap-2">
                          {ficheFabData._ouvriers_production.map(ouv => (
                            <div key={ouv.id} className="bg-green-50 border border-green-200 rounded-lg px-3 py-2 text-xs">
                              <span className="font-bold text-green-800">{ouv.nom}</span>
                              {ouv.specialite && <span className="text-green-600 ml-1">({ouv.specialite})</span>}
                              <span className="text-gray-500 ml-2">{ouv.nb_etapes} étape(s)</span>
                              {ouv.total_minutes > 0 && <span className="text-gray-500 ml-1">· {Math.round(ouv.total_minutes)} min</span>}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {ficheFabData._etapes_production.length > 0 && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1.5 font-semibold">Étapes réalisées</label>
                        <div className="space-y-1.5">
                          {ficheFabData._etapes_production.map((ep, idx) => (
                            <div key={idx} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs ${
                              ep.statut === 'termine' ? 'bg-green-50 border border-green-200' :
                              ep.statut === 'en_cours' ? 'bg-amber-50 border border-amber-200' :
                              'bg-gray-50 border border-gray-200'
                            }`}>
                              <span className={`w-2 h-2 rounded-full ${
                                ep.statut === 'termine' ? 'bg-green-500' : ep.statut === 'en_cours' ? 'bg-amber-500' : 'bg-gray-400'
                              }`} />
                              <span className="font-medium flex-1">{ep.nom_etape || ep.description || `Étape ${idx + 1}`}</span>
                              {ep.ouvrier_nom && <span className="text-gray-500">{ep.ouvrier_nom}</span>}
                              {ep.temps_reel_minutes > 0 && <span className="text-gray-400">{ep.temps_reel_minutes} min</span>}
                              {ep.date_debut && <span className="text-gray-400">{new Date(ep.date_debut).toLocaleDateString('fr-FR')}</span>}
                              <span className={`px-1.5 py-0.5 rounded font-semibold ${
                                ep.statut === 'termine' ? 'bg-green-200 text-green-800' :
                                ep.statut === 'en_cours' ? 'bg-amber-200 text-amber-800' : 'bg-gray-200 text-gray-600'
                              }`}>{ep.statut === 'termine' ? 'Fait' : ep.statut === 'en_cours' ? 'En cours' : 'Attente'}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {ficheFabData._etapes_fabrication.length > 0 && ficheFabData._etapes_production.length === 0 && (
                      <div>
                        <label className="block text-xs text-gray-500 mb-1.5 font-semibold">Étapes prévues</label>
                        <div className="space-y-1">
                          {ficheFabData._etapes_fabrication.map((et, idx) => (
                            <div key={idx} className={`flex items-center gap-2 px-3 py-1.5 rounded text-xs ${
                              et.statut === 'termine' ? 'bg-green-50' : 'bg-gray-50'
                            }`}>
                              <span className="font-bold text-gray-400 w-4">{et.ordre}</span>
                              <span className="flex-1">{et.nom}</span>
                              {et.temps_estime > 0 && <span className="text-gray-400">{et.temps_estime}h</span>}
                              <span className={et.statut === 'termine' ? 'text-green-600 font-semibold' : 'text-gray-400'}>
                                {et.statut === 'termine' ? 'Fait' : et.statut === 'en_cours' ? 'En cours' : 'Attente'}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* Footer */}
            {ficheFabData && (
              <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100 flex-shrink-0">
                <div className="text-xs text-gray-400">
                  {ficheFabData.composants.length} composant(s) · {ficheFabData.pierres_of.length} pierre(s)
                </div>
                <div className="flex items-center gap-3">
                  <button onClick={() => { setFicheFabBijouId(null); setFicheFabData(null); setFicheFabFichiers([]); }}
                    className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">
                    {isBoutique ? 'Fermer' : 'Annuler'}
                  </button>
                  {!isBoutique && (
                    <button onClick={sauverFicheFab} disabled={ficheFabSaving}
                      className="flex items-center gap-2 px-5 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-purple-300 text-white rounded-lg text-sm font-semibold transition-colors">
                      <Save className="h-4 w-4" />
                      {ficheFabSaving ? 'Enregistrement...' : 'Enregistrer la fiche'}
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Modal personnalisation d'une pièce ──────────────────────────── */}
      {pieceEnEdition && (
        <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/60 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-md max-h-[95vh] sm:max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <div>
                <h3 className="font-bold text-gray-900">Personnaliser la pièce</h3>
                <p className="text-sm text-gray-500 font-mono">{pieceEnEdition.id_produit} · {pieceEnEdition.reference_article}</p>
              </div>
              <button onClick={() => setPieceEnEdition(null)} className="p-2 hover:bg-gray-100 rounded-full">
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>
            <div className="px-6 py-4 space-y-4">
              {/* Couleur */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">Couleur de l'or</label>
                <div className="flex gap-3">
                  {[
                    { val: 'JAUNE', label: 'Or jaune', bg: 'bg-yellow-400', ring: 'ring-yellow-500' },
                    { val: 'BLANC', label: 'Or blanc', bg: 'bg-gray-300',   ring: 'ring-gray-500' },
                    { val: 'ROSE',  label: 'Or rose',  bg: 'bg-pink-300',   ring: 'ring-pink-500' },
                  ].map(({ val, label, bg, ring }) => (
                    <button key={val} onClick={() => setChampsPiece(c => ({ ...c, couleur_or: val }))}
                      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border-2 text-xs font-medium transition-all ${
                        champsPiece.couleur_or === val
                          ? 'border-gray-700 bg-gray-50'
                          : 'border-gray-200 hover:border-gray-300'
                      }`}>
                      <span className={`w-4 h-4 rounded-full ${bg}`} />
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Variations / personnalisations */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">Variations / personnalisations</label>
                <textarea
                  rows={3}
                  placeholder="Ex : taille 54, gravure initiales, pierre couleur spéciale..."
                  value={champsPiece.notes_variation || ''}
                  onChange={e => setChampsPiece(c => ({ ...c, notes_variation: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 resize-none"
                />
              </div>

              {/* Observations */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">Observations internes</label>
                <textarea
                  rows={2}
                  placeholder="Notes pour l'atelier..."
                  value={champsPiece.observation_piece || ''}
                  onChange={e => setChampsPiece(c => ({ ...c, observation_piece: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-purple-400 resize-none"
                />
              </div>

              {/* Options */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Options</label>
                <div className="grid grid-cols-2 gap-2">
                  {[
                    { key: 'rhodiage',     label: 'Rhodiage' },
                    { key: 'gravure_beldi',label: 'Gravure beldi' },
                    { key: 'ecrin',        label: 'Écrin' },
                    { key: 'garantie',     label: 'Garantie' },
                  ].map(({ key, label }) => (
                    <label key={key} className={`flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${
                      champsPiece[key] ? 'border-purple-300 bg-purple-50' : 'border-gray-200 hover:border-gray-300'
                    }`}>
                      <input type="checkbox" checked={!!champsPiece[key]}
                        onChange={e => setChampsPiece(c => ({ ...c, [key]: e.target.checked }))}
                        className="rounded text-purple-600" />
                      <span className="text-sm">{label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex items-center justify-end gap-3 px-6 py-3 border-t border-gray-100">
              <button onClick={() => setPieceEnEdition(null)}
                className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">
                Annuler
              </button>
              <button
                onClick={async () => {
                  try {
                    const res = await fetch(`${API_URL}/bijoux/${pieceEnEdition.id}/personnaliser`, {
                      method: 'PATCH',
                      headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(champsPiece),
                    });
                    if (res.ok) {
                      // Mettre à jour la pièce dans resultatLancement
                      setResultatLancement(prev => prev ? {
                        ...prev,
                        pieces: prev.pieces.map(p =>
                          p.id === pieceEnEdition.id ? { ...p, ...champsPiece } : p
                        )
                      } : null);
                      setPieceEnEdition(null);
                    } else {
                      const d = await res.json();
                      alert('Erreur : ' + (d.error || 'inconnue'));
                    }
                  } catch (e) {
                    alert('Erreur réseau : ' + e.message);
                  }
                }}
                className="px-5 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-semibold"
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-center px-4 pb-0">
        <div className="bg-white border border-gray-200 rounded-t-2xl shadow-2xl w-full max-w-3xl">

          {/* Header */}
          <button
            onClick={() => setPanierOuvert(!panierOuvert)}
            className="w-full flex items-center justify-between px-6 py-3 bg-green-600 rounded-t-2xl text-white hover:bg-green-700 transition-colors"
          >
            <div className="flex items-center space-x-3">
              <Play className="h-5 w-5 fill-current" />
              <span className="font-semibold">Lancer une production</span>
              {panier.length > 0 && (
                <span className="bg-white text-green-700 text-xs font-bold px-2 py-0.5 rounded-full">
                  {panier.reduce((t, i) => t + i.quantite, 0)} pièce(s)
                </span>
              )}
            </div>
            <ChevronUp className={`h-5 w-5 transition-transform ${panierOuvert ? 'rotate-180' : ''}`} />
          </button>

          {panierOuvert && (
            <div className="px-5 py-4 space-y-4 max-h-96 overflow-y-auto">

              {/* ── Client / Commande ── */}
              <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3">
                <label className="block text-xs font-bold text-blue-800 uppercase tracking-wide mb-1.5">
                  Pour qui ? (client / boutique)
                </label>
                <input
                  type="text"
                  placeholder="Ex : Athéna, Boutique Casa, stock..."
                  value={clientProd}
                  onChange={e => setClientProd(e.target.value)}
                  className="w-full px-3 py-2 border border-blue-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-400 bg-white"
                />
              </div>

              {/* ── Formulaire saisie nouvelle ligne ── */}
              <div className="bg-green-50 border border-green-200 rounded-xl p-4 space-y-3">
                <p className="text-xs font-bold text-green-800 uppercase tracking-wide">Ajouter une référence</p>
                <div className="flex gap-2 flex-wrap">
                  {/* Référence article OU id_produit */}
                  <div className="relative flex-1 min-w-[140px]">
                    <input
                      type="text"
                      placeholder="Ref BAGB12 ou ID 1.1432"
                      value={nouvelleLigne.reference_article}
                      onChange={e => {
                        // Ne pas uppercase si c'est un id_produit (chiffres+points)
                        const raw = e.target.value;
                        const val = /^\d+\.\d+/.test(raw) ? raw : raw.toUpperCase();
                        setNouvelleLigne({ ...nouvelleLigne, reference_article: val });
                        rechercherModele(val);
                      }}
                      onKeyDown={e => e.key === 'Enter' && ajouterLignePanier()}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm font-mono font-bold focus:ring-2 focus:ring-green-400 focus:border-transparent"
                    />
                    {lookupEnCours && (
                      <span className="absolute right-2 top-2.5 animate-spin h-4 w-4 border-2 border-green-500 border-t-transparent rounded-full" />
                    )}
                    {modeleInfo?.trouve === false && nouvelleLigne.reference_article.length >= 2 && !lookupEnCours && (
                      <span className="absolute right-2 top-2.5 text-xs text-amber-600" title="Bijou introuvable">?</span>
                    )}
                  </div>
                  {/* Désignation optionnelle */}
                  <input
                    type="text"
                    placeholder={modeleInfo?.modele?.nom || 'Désignation (optionnel)'}
                    value={nouvelleLigne.nom}
                    onChange={e => setNouvelleLigne({ ...nouvelleLigne, nom: e.target.value })}
                    className="flex-1 min-w-[140px] px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-400"
                  />
                </div>

                {/* Prévisualisation du modèle trouvé */}
                {modeleInfo?.trouve && modeleInfo.modele && (
                  <div className="bg-white border border-green-300 rounded-lg px-3 py-2 flex items-start gap-3 text-xs">
                    <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                      <span className="font-bold text-green-800">{modeleInfo.modele.nom}</span>
                      {modeleInfo.modele.collection_nom && <span className="text-gray-500 ml-2">· {modeleInfo.modele.collection_nom}</span>}
                      {modeleInfo.modele.poids && <span className="text-gray-500 ml-2">· {modeleInfo.modele.poids}g</span>}
                      {modeleInfo.modele.nb_existants > 0 && (
                        <span className="ml-2 text-blue-600">
                          {modeleInfo.modele.nb_existants} pièce(s) existante(s)
                          {modeleInfo.modele.nb_en_stock > 0 && ` (${modeleInfo.modele.nb_en_stock} en stock)`}
                        </span>
                      )}
                      {modeleInfo.modele.description && (
                        <p className="text-gray-500 mt-0.5 italic truncate">{modeleInfo.modele.description}</p>
                      )}
                    </div>
                  </div>
                )}
                {modeleInfo && !modeleInfo.trouve && nouvelleLigne.reference_article.length >= 3 && (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2 flex items-center gap-2 text-xs text-yellow-700">
                    <AlertCircle className="h-4 w-4 flex-shrink-0" />
                    Nouveau modèle — sera créé lors du lancement
                  </div>
                )}

                <div className="flex gap-3 items-center flex-wrap">
                  {/* Couleur or */}
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-gray-600 font-medium">Couleur :</span>
                    {[
                      { val: 'JAUNE', label: 'Or jaune', bg: 'bg-yellow-400', ring: 'ring-yellow-500' },
                      { val: 'BLANC', label: 'Or blanc', bg: 'bg-gray-300',   ring: 'ring-gray-500' },
                      { val: 'ROSE',  label: 'Or rose',  bg: 'bg-pink-300',   ring: 'ring-pink-500' },
                    ].map(({ val, label, bg, ring }) => (
                      <button
                        key={val}
                        onClick={() => setNouvelleLigne({ ...nouvelleLigne, couleur_or: val })}
                        title={label}
                        className={`w-7 h-7 rounded-full border-2 transition-all ${bg} ${
                          nouvelleLigne.couleur_or === val
                            ? `border-gray-700 ring-2 ${ring} scale-110`
                            : 'border-white opacity-70 hover:opacity-100'
                        }`}
                      />
                    ))}
                    <span className="text-xs font-semibold text-gray-700">{nouvelleLigne.couleur_or}</span>
                  </div>
                  {/* Quantité */}
                  <div className="flex items-center gap-1.5">
                    <span className="text-xs text-gray-600 font-medium">Qté :</span>
                    <button onClick={() => setNouvelleLigne(l => ({ ...l, quantite: Math.max(1, l.quantite - 1) }))}
                      className="w-7 h-7 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full">
                      <Minus className="h-3 w-3" />
                    </button>
                    <span className="w-8 text-center font-bold text-gray-800">{nouvelleLigne.quantite}</span>
                    <button onClick={() => setNouvelleLigne(l => ({ ...l, quantite: l.quantite + 1 }))}
                      className="w-7 h-7 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full">
                      <Plus className="h-3 w-3" />
                    </button>
                  </div>
                  <button
                    onClick={ajouterLignePanier}
                    disabled={!nouvelleLigne.reference_article.trim()}
                    className="ml-auto px-4 py-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-300 text-white rounded-lg text-sm font-semibold transition-colors"
                  >
                    + Ajouter
                  </button>
                </div>
              </div>

              {/* ── Liste des lignes ajoutées ── */}
              {panier.length > 0 && (
                <div className="space-y-2">
                  <p className="text-xs font-bold text-gray-500 uppercase tracking-wide">Lignes à produire</p>
                  {panier.map(item => (
                    <div key={item.id} className="flex items-center gap-3 bg-gray-50 rounded-lg px-4 py-2.5 border border-gray-100">
                      {/* Ref */}
                      <span className="font-mono font-bold text-sm text-purple-700 bg-purple-50 px-2 py-0.5 rounded min-w-[80px]">
                        {item.reference_article}
                      </span>
                      {/* Nom */}
                      <span className="flex-1 text-sm text-gray-700 truncate">{item.nom}</span>
                      {/* Couleur */}
                      <div className="flex items-center gap-1.5 flex-shrink-0">
                        {['JAUNE', 'BLANC', 'ROSE'].map(c => (
                          <button key={c} onClick={() => changerCouleurPanier(item.id, c)}
                            className={`w-5 h-5 rounded-full border-2 transition-all ${
                              item.couleur_or === c ? 'border-gray-700 scale-110' : 'border-white opacity-50 hover:opacity-90'
                            } ${c === 'JAUNE' ? 'bg-yellow-400' : c === 'BLANC' ? 'bg-gray-300' : 'bg-pink-300'}`}
                          />
                        ))}
                        <span className={`text-xs font-medium px-1.5 py-0.5 rounded ${
                          item.couleur_or === 'BLANC' ? 'bg-gray-100 text-gray-600' :
                          item.couleur_or === 'ROSE'  ? 'bg-pink-100 text-pink-600' :
                                                         'bg-yellow-100 text-yellow-700'
                        }`}>{item.couleur_or}</span>
                      </div>
                      {/* Quantité */}
                      <div className="flex items-center gap-1 flex-shrink-0">
                        <button onClick={() => changerQuantite(item.id, -1)}
                          className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full">
                          <Minus className="h-3 w-3" />
                        </button>
                        <span className="w-6 text-center font-bold text-sm">{item.quantite}</span>
                        <button onClick={() => changerQuantite(item.id, +1)}
                          className="w-6 h-6 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full">
                          <Plus className="h-3 w-3" />
                        </button>
                      </div>
                      <button onClick={() => retirerDuPanier(item.id)}
                        className="p-1 text-red-400 hover:text-red-600 rounded flex-shrink-0">
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Footer */}
          {panierOuvert && (
            <div className="flex items-center justify-between px-6 py-3 border-t border-gray-100 bg-gray-50">
              <button onClick={() => setPanier([])} className="text-sm text-gray-400 hover:text-red-500 transition-colors">
                Tout effacer
              </button>
              <button
                onClick={lancerProductionPanier}
                disabled={lancementEnCours || panier.length === 0}
                className="flex items-center gap-2 px-6 py-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition-colors"
              >
                {lancementEnCours
                  ? <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
                  : <Play className="h-4 w-4 fill-current" />}
                <span>{lancementEnCours ? 'Lancement...' : `Lancer — ${panier.reduce((t, i) => t + i.quantite, 0)} pièce(s)`}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>

      {/* Modal Historique Production */}
      {showHistoriqueModal && historiqueBijouId && (
        <HistoriqueProductionModal
          bijouId={historiqueBijouId}
          onClose={() => { setShowHistoriqueModal(false); setHistoriqueBijouId(null); }}
        />
      )}
    </>
  );
}

export default BijouxAvance;
